import React, { useContext, useState } from "react";
import {
  Button,
  Checkbox,
  Drawer,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Popover,
  Slider,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  styled,
} from "@mui/material";
import "./Map.scss";
import { renderToString } from "react-dom/server";
import {
  getColor,
  generatePopupContent,
  progressBarLabel,
  generateDataRange,
  buildContent,
  sortLimitedData,
  stringToNumber,
  generateDOMRange,
  getDOMColor,
} from "../utls";
import { authContext } from "../../../Context/Authentication/authContext";
import { Bars } from "react-loader-spinner";
import CloseIcon from "@mui/icons-material/Close";
import { baseURL } from "../../../config";
import satellite from "../../../../src/assets/satellite.png";
import terrain from "../../../../src/assets/valley.png";
import SatelliteIcon from "@mui/icons-material/Satellite";
import TerrainIcon from "@mui/icons-material/Terrain";
import { checkChange } from "@amcharts/amcharts4/.internal/core/utils/Time";
import MonthlyPredictionChart from "./mapChart";
import { isArray } from "@amcharts/amcharts4/core";

const REVERSE_SCALE = ["dom_growth_months", "days_on_market_mean"];
declare const google: any;

const getStateData = (
  chartData: any,
  profitability: string,
  type: string,
  selectTopRecords: any
) => {
  if (profitability === "All Zipcodes") {
    return sortLimitedData(chartData.chartData, type, selectTopRecords);
  } else {
    if (type === "high_expected_returns")
      return sortLimitedData(
        chartData.profitableExpectedReturn,
        type,
        selectTopRecords
      );
    if (type === "days_on_market_mean")
      return sortLimitedData(
        chartData.profitableDaysOnMarketReturn,
        type,
        selectTopRecords
      );
    if (type === "dom_growth_months")
      return sortLimitedData(
        chartData.profitableDaysOnMarketReturn,
        type,
        selectTopRecords
      );
    if (type === "home_sales_cumulative_mean")
      return sortLimitedData(
        chartData.profitableHomeSalesReturn,
        type,
        selectTopRecords
      );
    if (type === "hs_growth_months")
      return sortLimitedData(
        chartData.profitableHomeSalesReturn,
        type,
        selectTopRecords
      );
    if (type === "ppsf_Growth_mean")
      return sortLimitedData(
        chartData.profitablePpsfGrowthReturn,
        type,
        selectTopRecords
      );
  }
};

const COLORS = [
  "#6a0000",
  "#b50000",
  "#ff0000",
  "#ff5151",
  "#fff",
  "#9cff9c",
  "#51ff51",
  "#00ff00",
  "#00b500",
  "#006a00",
  "#004e00",
];

const PROFITABLE_COLORS = [
  "#fff",
  "#E6FF9A",
  "#DBFF73",
  "#CCFF57",
  "#B2EE45",
  "#9DD225",
  "#7EFF00",
  "#46C24C",
  "#469F77",
  "#006a00",
  "#004e00",
];

const layers = [
  {
    id: "0",
    value: "Fire",
  },
  {
    id: "2",
    value: "Flood",
  },
  {
    id: "3",
    value: "Hurricane",
  },
];

const HEATMAP_MONTH_OPTIONS = [
  "6",
  "12",
  "18",
  "24",
  "30",
  "36",
  "42",
  "48",
  "54",
];

const Florida_FIle_Names = [
  "Florida_Nassau_HighRisk",
  "Florida_StJohns_HighRisk",
  "Florida_Flagler_HighRisk",
  "Florida_Duval_HighRisk",
];
const California_Fire_Names = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
];

const MonthsSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? "#ACACA7" : "#ACACA7",
  height: 7,
  width: "284px",
  "& .MuiSlider-thumb": {
    width: "30px",
    height: "30px",
    background: "#3BDCC9",
    boxShadow: "0px 4px 4px 0px #00000040",
    "&:focus, &:hover, &.Mui-active": {
      boxShadow: "none !important",
    },
  },
  "& .MuiSlider-track": {
    color: "#ACACA7",
  },
}));

const PrettoSlider = styled(Slider)({
  color: "#fff",
  height: 4,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    // height: 24,
    // width: 24,
    backgroundColor: "#f7b047",
    border: "2px solid #f7b047",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    fontWeight: 600,
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    background:
      "linear-gradient(#fab144 -49.88%, rgba(255, 168, 13, 0.1) 102.13%)",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
  "& .MuiSlider-markLabel": {
    color: "#f7b047",
  },
});
const firePolygons = [];

const Map = (chartData: any) => {
  const { dispatch, state }: any = useContext(authContext);
  const [sliderValue, setSliderValue] = React.useState(
    state.filters.heatMapMonths || 6
  );
  const [showHighRisk, setShowHighRisk] = React.useState(
    state.filters.showHighRisk
  );
  const [Hmap, setHMap] = useState<any>(null);
  const [legendTitle, setLegendTittle] = useState<any>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLSpanElement | null>(null);
  const [riskType, setRiskType] = useState<string | null>(null);
  const [floodZone, setFloodZone] = useState<string | null>(null);
  const [schoolLevel, setSchoolLevel] = useState<string | null>(null);
  const [floodZoneSubType, setFloodZoneSubType] = useState<string | null>(null);
  const [floodZoneHUCCode, setFloodZoneHUCCode] = useState<string | null>(null);
  const [fireZone, setFireZone] = useState<string | null>(null);
  const [popoverContent, setPopoverContent] = useState<string | null>(null);
  const [layerLoading, setLayerLoading] = useState<boolean>(chartData.loading);
  const [mapType, setMapType] = useState("hybrid");
  const [showHeatMap, setShowHeatMap] = useState(state.filters.showHeatMap);
  const [showSchoolData, setShowSchoolData] = useState<boolean>(false);
  const [mapCenter, setMapCenter] = useState<any>(null);
  const [mapZoom, setMapZoom] = useState(null);
  const [fireDataLoaded, setFireDataLoaded] = useState(false);
  const [mapChart, setMapChart] = useState(false);
  const [mapChartData, setMapChartData] = useState<any>(null);

  const handleToggle = () => {
    setShowHeatMap(!showHeatMap);
  };
  const handleSchoolToggle = () => {
    setShowSchoolData(!showSchoolData);
    if(!showSchoolData && state.filters.showSchoolMap){

    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Function to handle drawer opening
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  // if(state.filters.showFireMap || state.filters.showFloodMap || state.filters.showSchoolMap){
  //   setShowHeatMap(false)
  // }

  React.useEffect(() => {
    let mapType = "high_expected_returns";
    const profitability = chartData.profitability || "All Zipcodes";
    const selectTopRecords = chartData.heatmapTopRecords || "All";
    const selectedQuarter = chartData.selectedQuarter || "2023-Q1";
    const selectedMonth = chartData.selectedMonth || "24";
    let stateData = getStateData(
      chartData,
      profitability,
      mapType,
      selectTopRecords
    );
    const geoData = chartData.geoData || {};
    let markersData = chartData.markers.length ? [...chartData.markers] : [];
    const showMarkers = chartData.showMarkers;
    const listeners: any[] = [];
    let markers: any[] = [];
    const schoolMarkers: google.maps.Marker[] = [];
    let schoolPolygons: google.maps.Polygon[] = [];
    let popup: any = null;
    let markerAdditionalInfo: any = {}; // Store all polygons
    const map = new google.maps.Map(document.getElementById("heatMap"), {
      zoom: selectTopRecords === "All" ? (stateData.length ? 6.8 : 3) : 9,
      mapTypeIds: [
        google.maps.MapTypeId.ROADMAP,
        google.maps.MapTypeId.SATELLITE,
        google.maps.MapTypeId.HYBRID,
        "Grayscale",
      ],
      mapTypeId: google.maps.MapTypeId.HYBRID,
      mapTypeControl: false,
      streetViewControl: false,
    });

    setHMap(map);

    const legendBox = document.createElement("div");
    legendBox.style.pointerEvents = "none";
    legendBox.setAttribute("id", "legend-box");
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(legendBox);
    const table = legendBox.appendChild(document.createElement("div"));
    table.setAttribute("id", "legend-range");
    table.style.fontFamily = "Arial, sans-serif"; // Example font family
    table.style.fontSize = "14px";
    table.style.color = mapType === "satellite" ? "white" : "white";
    table.style.fontFamily = "'Courier New', monospace";

    const bar = legendBox.appendChild(document.createElement("div"));
    bar.setAttribute("id", "range-bar");
    const barDiv = document.createElement("div");
    barDiv.setAttribute("id", "barDiv");
    bar.appendChild(barDiv);

    const title = legendBox.appendChild(document.createElement("div"));
    title.setAttribute("id", "title");
    title.style.fontWeight = "bold"; // Example bold font weight
    title.style.fontSize = "16px"; // Example font size
    title.style.color = mapType === "satellite" ? "white" : "white"; // Example color

    setLegendTittle(title);

    const displayMarkers = (map: any) => {
      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(map);
      }
    };

    const removeMarkers = (map: any) => {
      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }
    };

    const removeSchoolMarkers = (map: any) => {
      for (let i = 0; i < schoolMarkers.length; i++) {
        schoolMarkers[i].setMap(null);
      }
    };

    const removeGeoLocations = (map: any) => {
      map.data.forEach(function (feature: any) {
        map.data.remove(feature);
      });
    };

    const removeListeners = (map: any) => {
      for (let i = 0; i < listeners.length; i++) {
        listeners[i].remove();
      }
    };

    const buttonHandler = (type: string) => {
      switch (type) {
        case "days_on_market_mean":
          // @ts-ignore
          document
            .getElementById("high_expected_returns")
            .classList.remove("selected");
          // @ts-ignore
          document.getElementById(type).classList.add("selected");
          // @ts-ignore
          document
            .getElementById("home_sales_cumulative_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("ppsf_Growth_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("dom_growth_months")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("hs_growth_months")
            .classList.remove("selected");
          break;
        case "home_sales_cumulative_mean":
          // @ts-ignore
          document
            .getElementById("high_expected_returns")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("days_on_market_mean")
            .classList.remove("selected");
          // @ts-ignore
          document.getElementById(type).classList.add("selected");
          // @ts-ignore
          document
            .getElementById("ppsf_Growth_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("dom_growth_months")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("hs_growth_months")
            .classList.remove("selected");
          break;
        case "ppsf_Growth_mean":
          // @ts-ignore
          document
            .getElementById("high_expected_returns")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("days_on_market_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("home_sales_cumulative_mean")
            .classList.remove("selected");
          // @ts-ignore
          document.getElementById(type).classList.add("selected");
          // @ts-ignore
          document
            .getElementById("dom_growth_months")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("hs_growth_months")
            .classList.remove("selected");
          break;
        case "dom_growth_months":
          // @ts-ignore
          document
            .getElementById("high_expected_returns")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("days_on_market_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("home_sales_cumulative_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("ppsf_Growth_mean")
            .classList.remove("selected");
          // @ts-ignore
          document.getElementById(type).classList.add("selected");
          // @ts-ignore
          document
            .getElementById("hs_growth_months")
            .classList.remove("selected");
          break;
        case "hs_growth_months":
          // @ts-ignore
          document
            .getElementById("high_expected_returns")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("days_on_market_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("home_sales_cumulative_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("ppsf_Growth_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("dom_growth_months")
            .classList.remove("selected");
          // @ts-ignore
          document.getElementById(type).classList.add("selected");
          break;
        default:
          // @ts-ignore
          document
            .getElementById("high_expected_returns")
            .classList.add("selected");
          // @ts-ignore
          document
            .getElementById("days_on_market_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("home_sales_cumulative_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("ppsf_Growth_mean")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("dom_growth_months")
            .classList.remove("selected");
          // @ts-ignore
          document
            .getElementById("hs_growth_months")
            .classList.remove("selected");
      }
      return type;
    };

    map.addListener("center_changed", () => {
      const center = map.getCenter();
      if (center) {
        const newCenter = { lat: center.lat(), lng: center.lng() };

        setMapCenter(newCenter);
      }
    });

    map.addListener("zoom_changed", () => {
      let zoom = map.getZoom();
      setMapZoom(zoom);
    });

    document
      .getElementById("checkBox")
      ?.addEventListener("change", (event: any) => {
        const center = map.getCenter();
        const newZoom = map.getZoom();

        // Ensure you are in a valid context where 'center' is a LatLng object
        const newCenter = { lat: center.lat(), lng: center.lng() };

        setMapCenter(newCenter);

        setShowHeatMap(event.target.checked);
        drawMap(
          map,
          stateData,
          geoData,
          mapType,
          table,
          title,
          true,
          false,
          event.target.checked,
          newCenter,
          newZoom,
          showSchoolData
        );

        if (event.target.checked) {
          legendBox.style.display = "block";
          document
            .getElementById("high_expected_returns")
            ?.addEventListener("click", (event) => {
              mapType = buttonHandler("high_expected_returns");
              stateData = getStateData(
                chartData,
                profitability,
                mapType,
                selectTopRecords
              );
              drawMap(
                map,
                stateData,
                geoData,
                mapType,
                table,
                title,
                false,
                false,
                true
              );
            });
          // @ts-ignore
          document
            .getElementById("days_on_market_mean")
            .addEventListener("click", () => {
              mapType = buttonHandler("days_on_market_mean");
              stateData = getStateData(
                chartData,
                profitability,
                mapType,
                selectTopRecords
              );
              drawMap(
                map,
                stateData,
                geoData,
                mapType,
                table,
                title,
                false,
                false,
                true
              );
            });
          // @ts-ignore
          document
            .getElementById("home_sales_cumulative_mean")
            .addEventListener("click", () => {
              mapType = buttonHandler("home_sales_cumulative_mean");
              stateData = getStateData(
                chartData,
                profitability,
                mapType,
                selectTopRecords
              );
              drawMap(
                map,
                stateData,
                geoData,
                mapType,
                table,
                title,
                false,
                false,
                true
              );
            });
          // @ts-ignore
          document
            .getElementById("ppsf_Growth_mean")
            .addEventListener("click", () => {
              mapType = buttonHandler("ppsf_Growth_mean");
              stateData = getStateData(
                chartData,
                profitability,
                mapType,
                selectTopRecords
              );
              drawMap(
                map,
                stateData,
                geoData,
                mapType,
                table,
                title,
                false,
                false,
                true
              );
            });
          // @ts-ignore
          document
            .getElementById("dom_growth_months")
            .addEventListener("click", () => {
              mapType = buttonHandler("dom_growth_months");
              stateData = getStateData(
                chartData,
                profitability,
                mapType,
                selectTopRecords
              );
              drawMap(
                map,
                stateData,
                geoData,
                mapType,
                table,
                title,
                false,
                false,
                true
              );
            });
          // @ts-ignore
          document
            .getElementById("hs_growth_months")
            .addEventListener("click", () => {
              mapType = buttonHandler("hs_growth_months");
              stateData = getStateData(
                chartData,
                profitability,
                mapType,
                selectTopRecords
              );
              drawMap(
                map,
                stateData,
                geoData,
                mapType,
                table,
                title,
                false,
                false,
                true
              );
            });
        } else {
          legendBox.style.display = "none";
        }

        // setShowHeatMap(!showHeatMap)
      });
    document
      .getElementById("schoolCheckBox")
      ?.addEventListener("change", (event: any) => {
        const center = map.getCenter();
        const newZoom = map.getZoom();

        // Ensure you are in a valid context where 'center' is a LatLng object
        const newCenter = { lat: center.lat(), lng: center.lng() };

        setMapCenter(newCenter);

        setShowSchoolData(event.target.checked);
        drawMap(
          map,
          stateData,
          geoData,
          mapType,
          table,
          title,
          true,
          true,
          (document.getElementById("checkBox") as any).checked,
          newCenter,
          newZoom,
          event.target.checked
        );


        if ((document.getElementById("checkBox") as any).checked) {
          legendBox.style.display = "block";
        } else {
          legendBox.style.display = "none";
        }

        // setShowHeatMap(!showHeatMap)
      });

    // @ts-ignore
    if (showHeatMap) {
      document
        .getElementById("high_expected_returns")
        ?.addEventListener("click", (event) => {
          mapType = buttonHandler("high_expected_returns");
          stateData = getStateData(
            chartData,
            profitability,
            mapType,
            selectTopRecords
          );
          drawMap(
            map,
            stateData,
            geoData,
            mapType,
            table,
            title,
            false,
            false,
            true
          );
        });
      // @ts-ignore
      document
        .getElementById("days_on_market_mean")
        .addEventListener("click", () => {
          mapType = buttonHandler("days_on_market_mean");
          stateData = getStateData(
            chartData,
            profitability,
            mapType,
            selectTopRecords
          );
          drawMap(
            map,
            stateData,
            geoData,
            mapType,
            table,
            title,
            false,
            false,
            true
          );
        });
      // @ts-ignore
      document
        .getElementById("home_sales_cumulative_mean")
        .addEventListener("click", () => {
          mapType = buttonHandler("home_sales_cumulative_mean");
          stateData = getStateData(
            chartData,
            profitability,
            mapType,
            selectTopRecords
          );
          drawMap(
            map,
            stateData,
            geoData,
            mapType,
            table,
            title,
            false,
            false,
            true
          );
        });
      // @ts-ignore
      document
        .getElementById("ppsf_Growth_mean")
        .addEventListener("click", () => {
          mapType = buttonHandler("ppsf_Growth_mean");
          stateData = getStateData(
            chartData,
            profitability,
            mapType,
            selectTopRecords
          );
          drawMap(
            map,
            stateData,
            geoData,
            mapType,
            table,
            title,
            false,
            false,
            true
          );
        });
      // @ts-ignore
      document
        .getElementById("dom_growth_months")
        .addEventListener("click", () => {
          mapType = buttonHandler("dom_growth_months");
          stateData = getStateData(
            chartData,
            profitability,
            mapType,
            selectTopRecords
          );
          drawMap(
            map,
            stateData,
            geoData,
            mapType,
            table,
            title,
            false,
            false,
            true
          );
        });
      // @ts-ignore
      document
        .getElementById("hs_growth_months")
        .addEventListener("click", () => {
          mapType = buttonHandler("hs_growth_months");
          stateData = getStateData(
            chartData,
            profitability,
            mapType,
            selectTopRecords
          );
          drawMap(
            map,
            stateData,
            geoData,
            mapType,
            table,
            title,
            false,
            false,
            true
          );
        });
    }

    const getUrl = (index: any) => {
      if (index === "VE") {
        return "/kml/pin-red.png";
      } else if (index === "A") {
        return "/kml/pin-orange.png";
      } else if (index === "AE") {
        return "/kml/pin-yellow.png";
      } else if (index === "AO") {
        return "/kml/pin-green.png";
      } else if (index === "X") {
        return "/kml/pin-blue.png";
      } else {
        return "/kml/pin-lightGrey.png";
      }
    };

    const drawMarkers = (popup: any, type: string) => {
      for (let i = 0; i < markersData.length; i++) {
        const data = markersData[i];
        let url = `http://maps.google.com/mapfiles/ms/icons/${data.className}.png`;
        const marker = new google.maps.Marker({
          position: data.position,
          draggable: false,
          title: data.title,
          label: {
            text: data.cluster.toString(),
            className: "map-label-text",
          },
          icon: {
            url,
            scaledSize: new google.maps.Size(40, 40),
          },
        });
        const listener = marker.addListener("click", () => {
          popup.setContent(
            buildContent(
              data.properties,
              data.className,
              data.cluster,
              type,
              markerAdditionalInfo,
              state.user.email
            )
          );
          popup.setPosition(data.position);
          popup.open(map);
        });
        listeners.push(listener);
        marker.setAnimation(google.maps.Animation.DROP);
        markers.push(marker);
      }
    };
    function addLeadingZeroIfFourDigits(num: any) {
      let numStr = num.toString(); // Convert the number to a string
      return numStr.length === 4 ? `0${numStr}` : numStr;
    }

    // @ts-ignore

    const drawMap = (
      map: any,
      stateData: any,
      geoJsonData: any,
      type: any,
      table: any,
      title: any,
      iscenter: any,
      layerLoad: any,
      checked?: any,
      newCenter?: any,
      newZoom?: any,
      showSchool?: any
    ) => {
      const infoWindow = new google.maps.InfoWindow();
      if (checked) {
        removeMarkers(map);
        removeGeoLocations(map);
        removeListeners(map);
        if (popup) popup.close();

        var mapLayout:any={}
        popup = null;
     if(type!='days_on_market_mean'){
      mapLayout = generateDataRange(
        stateData,
        type,
        chartData.geoData
      );
     }
     else{
      mapLayout = generateDOMRange(
        stateData,
        type,
        chartData.geoData
      );
     }
        if (mapLayout.colorRange) {
          const colors = mapLayout.colorRange.map(([_, color]: any) => color);
          if (REVERSE_SCALE.includes(type)) {
            // @ts-ignore
            if (mapLayout.min < 0 && mapLayout.max > 0) {
              barDiv.classList.remove("profitable");
              barDiv.classList.add("non-profitable");
              barDiv.style.backgroundImage = `linear-gradient(to right, ${colors.join(
                ", "
              )})`;
            } else {
              barDiv.classList.remove("non-profitable");
              barDiv.classList.add("profitable");
              barDiv.style.backgroundImage = `linear-gradient(to right, ${colors.join(
                ", "
              )})`;
            }
          } else {
            // @ts-ignore
            if (mapLayout.min < 0) {
              barDiv.classList.remove("profitable");
              barDiv.classList.add("non-profitable");
              barDiv.style.backgroundImage = `linear-gradient(to right, ${colors.join(
                ", "
              )})`;
            } else {
              barDiv.classList.remove("non-profitable");
              barDiv.classList.add("profitable");
              barDiv.style.backgroundImage = `linear-gradient(to right, ${colors.join(
                ", "
              )})`;
            }
          }
        }

        console.log(mapLayout)
        const latitude = state.filters.stateCord.coOrd
          ? state.filters.stateCord.coOrd.lat
          : state.filters.stateCord.lat;
        const longitude = state.filters.stateCord.coOrd
          ? state.filters.stateCord.coOrd.lng
          : state.filters.stateCord.lng;
        table.innerHTML = "";
        // table
        let tableData = '<table style="width: 100%;"><tr style="display: flex; align-items: center; justify-content: space-between;"><td>';

        if (mapLayout.range.length !== 0) {
          for (let i in mapLayout.range) {
            tableData = tableData + mapLayout.range[i] + "</td><td>";
          }
        }
        tableData = tableData + "</td></tr></table>";
        table.innerHTML = tableData;

        title.innerHTML = "";
        title.innerHTML = progressBarLabel(type);
        markers = [];

        for (let i = 0; i < stateData.length; i++) {
          const data = stateData[i];

          // @ts-ignore
          const maxReturns = Math.ceil(data[type]);
          var polyColor:any

          if(type!='days_on_market_mean'){
            polyColor = getColor(
              mapLayout.min,
              mapLayout.max,
              maxReturns,
              type
            );

          }

          else{
            polyColor = getDOMColor(
              mapLayout.min,
              mapLayout.max,
              maxReturns,
              type,
              stateData,
              geoData
            );
          }


          
          let distanceFromFactoryCentre1 = data.distance_from_factory_centre1;
          let distanceFromFactoryCentre2 = data.distance_from_factory_centre2;
          let distanceFromFactoryCentre3 = data.distance_from_factory_centre3;
          if (distanceFromFactoryCentre1.toString() !== "0")
            distanceFromFactoryCentre1 = (
              Math.round(distanceFromFactoryCentre1 * 100) / 100
            ).toFixed(2);
          if (distanceFromFactoryCentre2.toString() !== "0")
            distanceFromFactoryCentre2 = (
              Math.round(distanceFromFactoryCentre2 * 100) / 100
            ).toFixed(2);
          if (distanceFromFactoryCentre3.toString() !== "0")
            distanceFromFactoryCentre3 = (
              Math.round(distanceFromFactoryCentre3 * 100) / 100
            ).toFixed(2);

          const clusterInfo = data.cluster;
          if (markerAdditionalInfo[clusterInfo]) {
            markerAdditionalInfo[clusterInfo].markerTotalHousesHolds2018 +=
              stringToNumber(data.total_house_holds_2018);
            markerAdditionalInfo[clusterInfo].markerTotalHousesHolds2021 +=
              stringToNumber(data.total_house_holds_2021);
            markerAdditionalInfo[clusterInfo].markerHouseHoldsGrowth1 +=
              stringToNumber(data.year_1_households_growth);
            markerAdditionalInfo[clusterInfo].markerHouseHoldsGrowth5 +=
              stringToNumber(data.year_5_houseHolds_growth);
            markerAdditionalInfo[clusterInfo].markerTotalPopulation2016 +=
              stringToNumber(data.total_population_2016);
            markerAdditionalInfo[clusterInfo].markerTotalPopulation2021 +=
              stringToNumber(data.total_population_2021);
            markerAdditionalInfo[clusterInfo].markerPopulationGrowth1 +=
              stringToNumber(data.year_1_population_growth);
            markerAdditionalInfo[clusterInfo].markerPopulationsGrowth5 +=
              stringToNumber(data.year_5_population_growth);
            markerAdditionalInfo[clusterInfo].count += 1;
          } else {
            markerAdditionalInfo[clusterInfo] = {
              markerTotalHousesHolds2018: stringToNumber(
                data.total_house_holds_2018
              ),
              markerTotalHousesHolds2021: stringToNumber(
                data.total_house_holds_2021
              ),
              markerTotalHousesHolds2023: stringToNumber(
                data.total_house_holds_2023
              ),
              markerHouseHoldsGrowth1: stringToNumber(
                data.year_1_households_growth
              ),
              markerHouseHoldsGrowth5: stringToNumber(
                data.year_5_houseHolds_growth
              ),
              markerTotalPopulation2018: stringToNumber(
                data.total_population_2018
              ),
              markerTotalPopulation2021: stringToNumber(
                data.total_population_2021
              ),
              markerTotalPopulation2023: stringToNumber(
                data.total_population_2023
              ),
              markerPopulationGrowth1: stringToNumber(
                data.year_1_population_growth
              ),
              markerPopulationsGrowth5: stringToNumber(
                data.year_5_population_growth
              ),
              count: 1,
            };
          }
          const properties = {
            factoryCentre1: data.factory_centre1,
            factoryCentre2: data.factory_centre2,
            factoryCentre3: data.factory_centre3,
            distanceFromFactoryCentre1,
            distanceFromFactoryCentre2,
            distanceFromFactoryCentre3,
            ppsf: data.ppsf,
            expectedPpsfMean: data.expected_ppsf_mean,
            ppsfGrowthMean: (
              Math.round(data.ppsf_Growth_mean * 100) / 100
            ).toFixed(2),
            medianSalePricePerHouse: data.median_sale_price_per_house,
            homeSaleCumulativeMean: data.home_sales_cumulative_mean,
            daysOnMarketMean: data.days_on_market_mean,
            highExpectedResults: (
              Math.round(data.high_expected_returns * 100) / 100
            ).toFixed(2),
            state: data.state,
            fill: polyColor,
            latitude: data.latitude,
            longitude: data.longitude,
            sameColor: data.same_color,
            cluster: data.cluster,
            zip: data.zcta5ce20,
            homeSalesMean: data.home_sales_mean,
            expectedHomeSales3Months: data.expected_home_sales_for_3_months,
            distanceFromProfitableZipcode:
              data.distance_from_profitable_zipcode,
            domGrowth: (Math.round(data.dom_growth_months * 100) / 100).toFixed(
              2
            ),
            hsGrowth: (Math.round(data.hs_growth_months * 100) / 100).toFixed(
              2
            ),
            totalHousesHolds2018: data.total_house_holds_2018,
            totalHousesHolds2023: data.total_house_holds_2023,
            houseHoldsGrowth1: data.year_1_households_growth,
            houseHoldsGrowth5: data.year_5_houseHolds_growth,
            totalPopulation2018: data.total_population_2018,
            totalPopulation2023: data.total_population_2023,
            populationGrowth1: data.year_1_population_growth,
            populationsGrowth5: data.year_5_population_growth,
          };

          const zcta5ce20 = addLeadingZeroIfFourDigits(data.zcta5ce20);
          if (Object.keys(geoJsonData).length) {
            const poly = geoJsonData[zcta5ce20];
            if (poly) {
              poly.properties = { ...poly.properties, ...properties };
              map.data.addGeoJson(poly, `zip-${zcta5ce20}`);
            }
          }
        }

        map.data.setStyle((feature: { getProperty: (arg0: string) => any }) => {
          return {
            // @ts-ignore
            fillColor: feature.getProperty("fill"),
            strokeWeight: 1,
            fillOpacity: 0.7,
          };
        });

        popup = new google.maps.InfoWindow();

        const listener = map.data.addListener(
          "click",
          (event: { latLng: any }) => {
            const htmlContent = generatePopupContent(
              event,
              type,
              selectedQuarter,
              selectedMonth,
              state.user.email
            );
            popup.setContent(htmlContent);
            popup.setPosition(event.latLng);
            popup.open(map);
            if (infoWindow) {
              infoWindow.close();
            }
          }
        );
        listeners.push(listener);
        drawMarkers(popup, type);
        if (state.user.email.split("@")[1] === "onxhomes.com" ) {
          displayMarkers(map);
        }
        const popupListener = google.maps.event.addListener(
          map,
          "click",
          function () {
            popup.close();
          }
        );
        listeners.push(popupListener);
        // @ts-ignore
        const getlat = () => {
          if (state.filters.heatMapCenter.lat != "") {
            return state.filters.heatMapCenter.lat.toString();
          }

          return latitude;
        };
        const getLng = () => {
          if (state.filters.heatMapCenter.lng != "") {
            return state.filters.heatMapCenter.lng.toString();
          }
          return longitude;
        };

        if (iscenter && !newCenter) {
          map.setCenter(new google.maps.LatLng(getlat(), getLng()));
        } else {
          map.setCenter(newCenter);
          map.setZoom(newZoom);
          // dispatch({
          //   type: "APPLY_FILTER",
          //   payload: {
          //     ...state?.filters,
          //     heatMapCenter: mapCenter,
          //     heatMapZoom:mapZoom
          //   },
          // });
        }
      }

      if (state.filters.showFloodMap && layerLoad) {
        const allCoords: any = []; // To store all coordinates
        const dist = new Set();

        // Create a single InfoWindow instance

        Florida_FIle_Names.map((name) => {
          const URL = "/kml/" + name + ".kml";
          fetch(URL)
            .then((response) => response.text())
            .then((kmlText) => {
              const parser = new DOMParser();
              const kmlDoc = parser.parseFromString(kmlText, "text/xml");

              // Extract placemarks and add markers
              const placemarks = kmlDoc.getElementsByTagName("Placemark");

              for (let i = 0; i < placemarks.length; i++) {
                const placemark: any = placemarks[i];

                const coordinates =
                  placemark
                    .getElementsByTagName("coordinates")[0]
                    .textContent.trim() || "";
                const [lng, lat] = coordinates.split(",").map(Number);
                allCoords.push({ lat, lng }); // Store coordinates for center calculation

                const simpleData = placemark.getElementsByTagName("SimpleData");
                const data: any = {};
                Array.from(simpleData).forEach((item: any) => {
                  const name = item.getAttribute("name");
                  const value = item.textContent;
                  data[name] = value;
                });

                const marker = new google.maps.Marker({
                  position: { lat, lng },
                  map: map,
                  icon: {
                    url: getUrl(data["FLD_ZONE"]),
                    scaledSize: new google.maps.Size(32, 32),
                  },
                });
                const handleMarkerClick = (infoWindow: any, data: any) => {
                  // Open the info window and attach the click event for the info icon
                  infoWindow.open(map, marker);

                  // Wait for the DOM to render
                  // Delay to ensure DOM is updated
                  if (data["INUN_RSK"] != "-999") {
                    setTimeout(() => {
                      // Replace placeholder with actual Material UI icon
                      const placeholder = document.getElementById(
                        "info-icon-placeholder"
                      );
                      if (placeholder) {
                        const iconElement = document.createElement("span");

                        iconElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24" style="fill: #f7b047;position:relative;top:7px; cursor: pointer;"
                        viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-13h-2v2h2V7zm0 4h-2v6h2v-6z"/></svg>`;
                        iconElement.onclick = function (event: any) {
                          const parentElement =
                            event.currentTarget.parentElement;
                          const parentRect =
                            parentElement.getBoundingClientRect();
                          const iconRect =
                            event.currentTarget.getBoundingClientRect();
                          setAnchorEl(event.currentTarget as HTMLSpanElement);
                          setMapChart(false);
                          setRiskType(data["INUN_RSK"]);
                          setPopoverContent("inundationRisk");
                        };
                        placeholder.appendChild(iconElement);
                      }
                    }, 100);
                  }
                  const floodIcon = document.getElementById(
                    "info-icon-placeholder-flood"
                  );
                  setTimeout(() => {
                    // Replace placeholder with actual Material UI icon
                    const placeholder = document.getElementById(
                      "info-icon-placeholder-flood"
                    );
                    if (placeholder) {
                      const iconElement = document.createElement("span");
                      iconElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24" style="fill: #f7b047;position:relative;top:7px; cursor: pointer;"
                      viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-13h-2v2h2V7zm0 4h-2v6h2v-6z"/></svg>`;
                      iconElement.onclick = function (event) {
                        setAnchorEl(event.currentTarget as HTMLSpanElement);
                        setMapChart(false);
                        setPopoverContent("floodIcon");
                        setFloodZone(data["FLD_ZONE"]);
                      };
                      placeholder.appendChild(iconElement);
                    }
                  }, 100);

                  if (
                    data["ZONE_SUBTY"] != "2000" &&
                    data["ZONE_SUBTY"] != "0500" &&
                    data["ZONE_SUBTY"] != "1100" &&
                    data["ZONE_SUBTY"] != 2000 &&
                    data["ZONE_SUBTY"] != 0o500 &&
                    data["ZONE_SUBTY"] != 1100
                  ) {
                    setTimeout(() => {
                      // Replace placeholder with actual Material UI icon
                      const placeholder = document.getElementById(
                        "info-icon-placeholder-flood-subType"
                      );
                      if (placeholder) {
                        const iconElement = document.createElement("span");
                        iconElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24" style="fill: #f7b047;position:relative;top:7px; cursor: pointer;"
                      viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-13h-2v2h2V7zm0 4h-2v6h2v-6z"/></svg>`;
                        iconElement.onclick = function (event) {
                          setAnchorEl(event.currentTarget as HTMLSpanElement);
                          setMapChart(false);
                          setPopoverContent("floodSubType");
                          setFloodZoneSubType(data["ZONE_SUBTY"]);
                        };
                        placeholder.appendChild(iconElement);
                      }
                    }, 100);
                  }

                  setTimeout(() => {
                    // Replace placeholder with actual Material UI icon
                    const placeholder = document.getElementById(
                      "info-icon-placeholder-flood-HUCCode"
                    );
                    if (placeholder) {
                      const iconElement = document.createElement("span");
                      iconElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24" style="fill: #f7b047;position:relative;top:7px; cursor: pointer;"
                      viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-13h-2v2h2V7zm0 4h-2v6h2v-6z"/></svg>`;
                      iconElement.onclick = function (event) {
                        setAnchorEl(event.currentTarget as HTMLSpanElement);
                        setMapChart(false);
                        setPopoverContent("floodHUCCode");
                        setFloodZoneHUCCode(data["HUC8_CODE"]);
                      };
                      placeholder.appendChild(iconElement);
                    }
                  }, 100);
                };

                const getKeyValueHtml = (title: any, value: any) => {
                  // Skip adding the key-value pair if the value is -999 or -9999

                  if (
                    value === -999 ||
                    value === -9999 ||
                    value === undefined ||
                    value === "N/A" ||
                    value === "-999" ||
                    value === "-9999"
                  )
                    return "";
                  else if (title === "Flood Zone") {
                    return `
                    <div class='nav-container-col'>
                      <div class='nav-container-title'>${title}:
                      <span id="info-icon-placeholder-flood"></span></div>
                      <div class='nav-container-value'>${value}</div>
                    </div>
                  `;
                  } else if (title === "Inundation Risk") {
                    return `
                    <div class='nav-container-col'>
                      <div class='nav-container-title'>${title}:
                      <span id="info-icon-placeholder"></div>
                      <div class='nav-container-value'>${value}</div>
                    </div>
                  `;
                  } else if (title === "Zone Subtype") {
                    return `
                    <div class='nav-container-col'>
                      <div class='nav-container-title'>${title}:
                      <span id="info-icon-placeholder-flood-subType"></div>
                      <div class='nav-container-value'>${value}</div>
                    </div>
                  `;
                  } else if (title === "HUC Code") {
                    return `
                    <div class='nav-container-col'>
                      <div class='nav-container-title'>${title}:
                      <span id="info-icon-placeholder-flood-HUCCode"></div>
                      <div class='nav-container-value'>${value}</div>
                    </div>
                  `;
                  }
                  return `
                    <div class='nav-container-col'>
                      <div class='nav-container-title'>${title}:</div>
                      <div class='nav-container-value'>${value}</div>
                    </div>
                  `;
                };

                const infoWindowContent = `<div id='map-tooltip'>
                  <div class='nav-bar'>
                    <div class='nav-title'>
                      <span>High Risk Flood Data</span>
                    </div>
                  </div>
                  <div class='nav-container'>
                  ${getKeyValueHtml("Flood Zone", data["FLD_ZONE"])}
                  ${getKeyValueHtml("Inundation Risk", data["INUN_RSK"])}
                    ${getKeyValueHtml("City", data["POL_NAME1"])}
                    ${getKeyValueHtml("Site Info", data["Site_Info"])} 
                    ${getKeyValueHtml(
                      "Zone Subtype",
                      data["ZONE_SUBTY"]
                    )}                            
                    ${getKeyValueHtml("Wave Hazard Risk", data["WAVHAZ_RSK"])}
                    ${getKeyValueHtml(
                      "Depth 0.2%",
                      parseFloat(parseFloat(data["DPTH0_2PCT"]).toFixed(2))
                    )}
                    ${getKeyValueHtml(
                      "Depth 1%",
                      parseFloat(parseFloat(data["DPTH1PCT"]).toFixed(2))
                    )}
                    ${getKeyValueHtml(
                      "Depth 2%",
                      parseFloat(parseFloat(data["DPTH2PCT"]).toFixed(2))
                    )}
                    ${getKeyValueHtml(
                      "Depth 4%",
                      parseFloat(parseFloat(data["DPTH4PCT"]).toFixed(2))
                    )}
                    ${getKeyValueHtml(
                      "Depth 10%",
                      parseFloat(parseFloat(data["DPTH10PCT"]).toFixed(2))
                    )}
                    ${getKeyValueHtml(
                      "Depth 25%",
                      parseFloat(parseFloat(data["DPTH25PCT"]).toFixed(2))
                    )}
                    ${getKeyValueHtml(
                      "Depth 50%",
                      parseFloat(parseFloat(data["DPTH50PCT"]).toFixed(2))
                    )}
                    
                  </div>
                </div>`;

                marker.addListener("click", () => {
                  if (popup) {
                    popup.close();
                  }
                  infoWindow.setContent(infoWindowContent); // Set the content of the InfoWindow
                  infoWindow.open(map, marker); // Open the InfoWindow on the clicked marker
                });
                marker.addListener("click", () =>
                  handleMarkerClick(infoWindow, data)
                );
              }

              // Calculate center of all points
              if (allCoords.length > 0) {
                const latSum = allCoords.reduce(
                  (sum: any, coord: any) => sum + coord.lat,
                  0
                );
                const lngSum = allCoords.reduce(
                  (sum: any, coord: any) => sum + coord.lng,
                  0
                );
                const centerLat = latSum / allCoords.length;
                const centerLng = lngSum / allCoords.length;

                map.setCenter({ lat: centerLat, lng: centerLng }); // Set the map center
                map.setZoom(8); // Optionally set the zoom level
              }
            })
            .catch((error) => {
              console.error("Error loading KML file:", error);
            });
        });
      }

      if (state.filters.showSchoolMap && layerLoad) {
        if (chartData.schoolData && showSchool && schoolMarkers.length === 0) {
          const bounds = new google.maps.LatLngBounds();

          chartData.schoolData.forEach((data: any) => {
            const { lat, lon } = data;

            const position = {
              lat: parseFloat(lat),
              lng: parseFloat(lon),
            };

            bounds.extend(position);

            const marker = new google.maps.Marker({
              position,
              map: showSchool ? map : null, // Only show on map if showSchool is true
              icon: {
                url: "/kml/school.png",
                scaledSize: new google.maps.Size(25, 25),
              },
            });

            schoolMarkers.push(marker); // Store the marker in the array for later use

            const getKeyValueHtml = (title: any, value: any) => {
              // Skip adding the key-value pair if the value is -999 or -9999
              if (
                value === -999 ||
                value === -9999 ||
                value === "No Data" ||
                value === undefined ||
                value === "N/A" ||
                value === null ||
                value === "" ||
                value === "NOT AVAILABLE"
              )
                return "";

              if (title === "Level Codes") {
                return ` <div class='nav-container-col'>
                      <div class='nav-container-title'>${title}:
                      <span id="info-icon-placeholder"></div>
                      <div class='nav-container-value'>${value}</div>
                    </div>`;
              }

              return `
            <div class='nav-container-col'>
              <div class='nav-container-title'>${title}:</div>
              <div class='nav-container-value'>${
                value === "null" ? "Not Available" : value
              }</div>
            </div>
          `;
            };
            const mailingAddress =
              (data.mailStrAbr ? data.mailStrAbr : "") +
              (data.mailCity ? ", " + data.mailCity : "") +
              (data.mailState ? ", " + data.mailState : "") +
              (data.mailZip ? " " + data.mailZip : "");

            const adminName =
              (data.admFName ? data.admFName : "") +
              (data.admLName ? " " + data.admLName : "");

            const infoWindowContent = `
          <div id='map-tooltip'>
            <div class='nav-bar'>
              <div class='nav-title'>
                <span>School Information</span>
              </div>
            </div>
            <div class='nav-container'>
              <!-- Existing fields -->
              ${getKeyValueHtml("School Name", data.name)}
              ${getKeyValueHtml("School Summary", data.schoolSummary)}
              ${getKeyValueHtml("School Type", data.type)}
              ${getKeyValueHtml("Level Codes", data.levelCodes)}
              ${getKeyValueHtml("Grades Served", data.level)}
              ${getKeyValueHtml("Street Address", data.street)}
              ${getKeyValueHtml("City", data.city)}
              ${getKeyValueHtml("State", data.state)}
              ${getKeyValueHtml("County", data.county)}
              ${getKeyValueHtml("Zip Code", data.zip)}
              ${getKeyValueHtml("Phone", data.phone)}
              ${getKeyValueHtml("Fax Number", data.fax)}
              ${getKeyValueHtml("District Name", data.districtName)}
              ${getKeyValueHtml("District ID", data.districtId)}
              ${getKeyValueHtml("Website", data.webSite)}
              ${getKeyValueHtml("Rating Band", data.ratingBand)}
              ${getKeyValueHtml("Latitude", data.lat)}
              ${getKeyValueHtml("Longitude", data.lon)}
            </div>
          </div>
        `;

            marker.addListener("click", () => {
              if (popup) {
                popup.close();
              }
              infoWindow.setContent(infoWindowContent);
              infoWindow.open(map, marker);
            });
          });

          if (schoolMarkers.length > 0) {
            map.fitBounds(bounds);
          }
        } else if (schoolMarkers.length > 0) {
          // If markers already exist, just toggle their visibility
          schoolMarkers.forEach((marker) => {
            marker.setMap(showSchool ? map : null);
          });
          
        }

        // Store polygons in an array outside this function
        // (Assuming schoolPolygons is declared outside this function)

        // Only load and create polygons if they haven't been created yet
        if (schoolPolygons.length === 0) {
          const names = [
            "California_School.geojson",
            "California_School_2.json",
            "California_School_3.json",
          ];

          if (state.filters.state === "California") {
            names.forEach((name) => {
              fetch(`/School_Boundaries/${name}`) // Update with actual path
                .then((response) => response.json())
                .then((geojson) => {
                  const bounds = new google.maps.LatLngBounds(); // Initialize the bounds object

                  geojson.features.forEach((feature: any) => {
                    if (feature.geometry.type === "Polygon") {
                      // Handle Polygon - coordinates are [[lat, lng]]
                      const paths = feature.geometry.coordinates[0].map(
                        ([lng, lat]: [number, number]) => ({ lat, lng })
                      );
                      createPolygon(paths, feature, map, infoWindow, bounds);
                    } else if (feature.geometry.type === "MultiPolygon") {
                      // Handle MultiPolygon - coordinates are [[[lat, lng]]]
                      feature.geometry.coordinates.forEach(
                        (polygonCoords: any) => {
                          const paths = polygonCoords[0].map(
                            ([lng, lat]: [number, number]) => ({ lat, lng })
                          );
                          createPolygon(
                            paths,
                            feature,
                            map,
                            infoWindow,
                            bounds
                          );
                        }
                      );
                    }
                  });

                  // After processing all features, adjust the map to fit the bounds
                  map.fitBounds(bounds); // Fit the map to the bounds of the polygons
                })
                .catch((error) =>
                  console.error("Error loading GeoJSON:", error)
                );
            });
          } else {
            fetch(`/SchoolBoundaries/${state.filters.selectedTerritory}.json`)
              .then((response) => response.json())
              .then((geojson) => {
                const bounds = new google.maps.LatLngBounds(); // Initialize the bounds object

                geojson.features.forEach((feature: any) => {
                  if (feature.geometry.type === "Polygon") {
                    // Handle Polygon - coordinates are [[lat, lng]]
                    const paths = feature.geometry.coordinates[0].map(
                      ([lng, lat]: [number, number]) => ({ lat, lng })
                    );
                    createPolygon(paths, feature, map, infoWindow, bounds);
                  } else if (feature.geometry.type === "MultiPolygon") {
                    // Handle MultiPolygon - coordinates are [[[lat, lng]]]
                    feature.geometry.coordinates.forEach(
                      (polygonCoords: any) => {
                        const paths = polygonCoords[0].map(
                          ([lng, lat]: [number, number]) => ({ lat, lng })
                        );
                        createPolygon(paths, feature, map, infoWindow, bounds);
                      }
                    );
                  }
                });

                // After processing all features, adjust the map to the bounds
                map.fitBounds(bounds); // Fit the map to the bounds of the polygons
              })
              .catch((error) => console.error("Error loading GeoJSON:", error));
          }

          // Helper function to create polygon with consistent styling and event handlers
          function createPolygon(
            paths: google.maps.LatLngLiteral[],
            feature: any,
            map: google.maps.Map,
            infoWindow: google.maps.InfoWindow,
            bounds: google.maps.LatLngBounds
          ) {
            const polygon = new google.maps.Polygon({
              paths,
              strokeColor: "#FF0000",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "blue",
              fillOpacity: 0.35,
              map,
            });

            // Add the polygon to our array for future reference
            schoolPolygons.push(polygon);

            // Extend the bounds to include the current polygon
            paths.forEach((path) => {
              bounds.extend(new google.maps.LatLng(path.lat, path.lng));
            });

            polygon.addListener(
              "click",
              (event: google.maps.PolyMouseEvent) => {
                const infoWindowContent = `
                <div id='map-tooltip'>
                  <div class='nav-bar'>
                    <div class='nav-title'>
                      <span>School District Information</span>
                    </div>
                  </div>
                  <div class='nav-container'>
                    District Area Name: ${feature.properties.NAME}
                  </div>
                </div>
              `;
                infoWindow.setContent(infoWindowContent);
                infoWindow.setPosition(event.latLng);
                infoWindow.open(map);
              }
            );
          }
        }
      }

      if (state.filters.showFireMap && layerLoad) {
        if (!fireDataLoaded) {
          setLayerLoading(true);
          const dist = new Set();
          const allCoordinates: { lat: number; lng: number }[] = [];
          const pageSize = 1000; // Define the chunk size
          let isFetching = false; // Flag to prevent multiple fetchAllPages calls

          const category = "all";

          var fetchCount = 0;

          const calculateCentroid = (
            coords: { lat: number; lng: number }[]
          ) => {
            let latSum = 0;
            let lngSum = 0;
            const numPoints = coords.length;

            coords.forEach((coord) => {
              latSum += coord.lat;
              lngSum += coord.lng;
            });

            return { lat: latSum / numPoints, lng: lngSum / numPoints };
          };

          const drawPolygon = (
            coordinates: any,
            properties: any,
            count: any
          ) => {
            const polygon = new google.maps.Polygon({
              paths: coordinates,
              strokeColor: properties.stroke || "#ff0000",
              strokeOpacity: properties["stroke-opacity"] || 1,
              strokeWeight: 1.5,
              fillColor:
                properties["HAZ_CLASS"] === "Very High" ? "#ff7f50" : "#ffa500",
              fillOpacity: properties["fill-opacity"] || 0.4,
              map: map,
            });
            firePolygons.push(polygon);

            const infoWindowContent = `
              <div id='map-tooltip'>
                <div class='nav-bar'>
                  <div class='nav-title'>
                    <span>Hazard Data</span>
                  </div>
                </div>
                <div class='nav-container'>
                  <div class='nav-container-col'>
                    <div class='nav-container-title'>Responsibility Area:</div>
                    <div class='nav-container-value'>${
                      properties["SRA"] || "N/A"
                    }
                    &nbsp;<span id="info-icon-placeholder-fire"></span></div>
                  </div>
                  <div class='nav-container-col'>
                    <div class='nav-container-title'>Hazard Class:</div>
                    <div class='nav-container-value'>${
                      properties["HAZ_CLASS"] || "N/A"
                    }</div>
                  </div>
                </div>
              </div>
            `;

            polygon.addListener("click", () => {
              if (popup) {
                popup.close();
              }
              setTimeout(() => {
                // Replace placeholder with actual Material UI icon
                const placeholder = document.getElementById(
                  "info-icon-placeholder-fire"
                );
                if (placeholder) {
                  const iconElement = document.createElement("span");
                  iconElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24" style="fill: #f7b047;position:relative;top:7px; cursor: pointer;"
                      viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-13h-2v2h2V7zm0 4h-2v6h2v-6z"/></svg>`;
                  iconElement.onclick = function (event) {
                    setAnchorEl(event.currentTarget as HTMLSpanElement);
                    setMapChart(false);
                    setPopoverContent("fireIcon");
                    setFireZone(properties["SRA"]);
                  };
                  placeholder.appendChild(iconElement);
                }
              }, 100);
              const centroid = calculateCentroid(coordinates);
              infoWindow.setContent(infoWindowContent);
              infoWindow.setPosition(centroid);
              infoWindow.open(map);
            });

            // Set the map center when count is 2
            if (count === 2 && allCoordinates.length > 0) {
              setLayerLoading(false);
            } else if (count === 1 && allCoordinates.length > 0) {
              const centroid = calculateCentroid(allCoordinates);
              map.setCenter(new google.maps.LatLng(centroid.lat, centroid.lng));
            }
          };

          const fetchPageData = async (page: any) => {
            try {
              const response = await fetch(
                `${baseURL}getFireCoordinatesBySeverity?state=California&category=${category}&page=${page}&size=${pageSize}`
              );
              return response.json();
            } catch (error) {
              console.error(`Error fetching page ${page}:`, error);
              return null;
            }
          };

          const fetchTotalPages = async () => {
            try {
              const response = await fetch(
                `${baseURL}getFireCoordinatesBySeverityCount?state=California&size=${pageSize}&category=${category}`
              );
              return response.json();
            } catch (error) {
              console.error(`Error fetching`, error);
              return null;
            }
          };

          const processPageData = (data: any, count: any) => {
            if (data && data.cube && Array.isArray(data.cube)) {
              data.cube.forEach((feature: any) => {
                const properties = JSON.parse(feature.properties);
                try {
                  const rawCoordinates = JSON.parse(feature.coordinates);

                  rawCoordinates.forEach((polygon: any) => {
                    const formattedCoordinates = polygon
                      .map(([lng, lat]: any) => {
                        const parsedLat = parseFloat(lat);
                        const parsedLng = parseFloat(lng);

                        if (isNaN(parsedLat) || isNaN(parsedLng)) {
                          console.warn(
                            "Invalid coordinates detected, skipping:",
                            { lat, lng }
                          );
                          return null;
                        }

                        return { lat: parsedLat, lng: parsedLng };
                      })
                      .filter((coord: any) => coord !== null);

                    if (formattedCoordinates.length > 0) {
                      formattedCoordinates.forEach((coord: any) =>
                        allCoordinates.push(coord)
                      );
                      if (properties["SRA"]) {
                        dist.add(properties["SRA"]);
                      }
                      drawPolygon(formattedCoordinates, properties, count);
                    }
                  });
                } catch (parseError) {
                  console.error("Error parsing coordinates:", parseError);
                }
              });
            }
          };

          const fetchAndProcessPages = async () => {
            if (isFetching) return;
            isFetching = true;

            try {
              // First, fetch initial page to get the total number of pages
              const initialData = await fetchTotalPages();
              const totalPages = initialData.totalPages;

              // Create an array of fetch promises
              const fetchPromises = [];
              for (let page = 0; page <= totalPages; page++) {
                fetchPromises.push(
                  fetchPageData(page).then((data) => {
                    fetchCount = fetchCount + 1;

                    if (data) {
                      processPageData(data, fetchCount);
                    }
                  })
                );
              }

              // Execute all fetches concurrently
              await Promise.all(fetchPromises);

              // Optionally set the map center here if needed
              if (allCoordinates.length > 0) {
                const centroid = calculateCentroid(allCoordinates);
                map.setCenter(
                  new google.maps.LatLng(centroid.lat, centroid.lng)
                );
                // Optionally set the zoom level if desired
                // map.setZoom(10); // Adjust zoom level as needed
              }
            } catch (error) {
              console.error("Error fetching or processing data:", error);
            } finally {
              setLayerLoading(false);
              setFireDataLoaded(true);
              isFetching = false;
            }
          };

          // Start fetching and processing pages
          fetchAndProcessPages();
        } else {
        }
      }
      if (state.filters.showHurricaneMap && layerLoad) {
        if (chartData.hurricaneData) {
          const getCentroid = (coordinates: any) => {
            let latSum = 0;
            let lngSum = 0;
            const numCoords = coordinates.length;

            coordinates.forEach(([lng, lat]: any) => {
              latSum += parseFloat(lat);
              lngSum += parseFloat(lng);
            });

            return { lat: latSum / numCoords, lng: lngSum / numCoords };
          };
          chartData.hurricaneData.forEach((feature: any) => {
            const coordinates = feature.geometry.coordinates[0].map(
              (coord: any) => {
                const [lng, lat] = coord; // Extract latitude and longitude
                return { lat: parseFloat(lat), lng: parseFloat(lng) }; // Convert to float to ensure they are numbers
              }
            );

            const centroid = getCentroid(feature.geometry.coordinates[0]);

            // Create a new polygon and set its path
            const polygon = new google.maps.Polygon({
              paths: coordinates,
              strokeColor:
                JSON.parse(feature.properties["disasterPred"]).severity ===
                "Relatively Low"
                  ? "yellow"
                  : JSON.parse(feature.properties["disasterPred"]).severity ===
                    "Relatively High"
                  ? "red"
                  : "orange",
              strokeOpacity: 1,
              strokeWeight: 1.5,
              fillColor:
                JSON.parse(feature.properties["disasterPred"]).severity ===
                "Relatively Low"
                  ? "yellow"
                  : JSON.parse(feature.properties["disasterPred"]).severity ===
                    "Relatively High"
                  ? "red"
                  : "orange",
              fillOpacity: 0.4,
              map: map,
            });
            const infoWindowContent = `
            <div id='map-tooltip'>
              <div class='nav-bar'>
                <div class='nav-title'>
                  <span>Hazard Data</span>
                </div>
              </div>
              <div class='nav-container'>
                <div class='nav-container-col'>
                  <div class='nav-container-title'>County:</div>
                  <div class='nav-container-value'>${
                    feature.properties["county"] || "N/A"
                  }
                  &nbsp;<span id="info-icon-placeholder-fire"></span></div>
                </div>
                <div class='nav-container-col'>
                  <div class='nav-container-title'>Hazard Type:</div>
                  <div class='nav-container-value'>${
                    feature.properties["disasterType"] || "N/A"
                  }</div>
                </div>
                <div class='nav-container-col'>
                <div class='nav-container-title'>Severity:
                <span id="chart-icon"></span></div>
                <div class='nav-container-value'>${
                  JSON.parse(feature.properties["disasterPred"]).severity ||
                  "N/A"
                }</div>
              </div>
              </div>
            </div>
          `;

            polygon.addListener("click", () => {
              if (popup) {
                popup.close();
              }
              setTimeout(() => {
                // Replace placeholder with actual Material UI icon
                const placeholder = document.getElementById("chart-icon");
                if (placeholder) {
                  const iconElement = document.createElement("span");
                  iconElement.innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" height="22" style="fill: none; position: relative; top: 4px; cursor: pointer;"
                      viewBox="0 0 24 24" width="24">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M3 3v18h18" stroke="#f7b047" stroke-width="1.5" fill="none"/> <!-- Y-Axis -->
                    <path d="M3 21H21" stroke="#f7b047" stroke-width="1.5" fill="none"/> <!-- X-Axis -->
                    <path d="M4 14l4-4 4 5 5-7 3 4" fill="none" stroke="#f7b047" stroke-width="2"/> <!-- Line Chart -->
                    <circle cx="4" cy="14" r="1.5" fill="#f7b047"/> <!-- Data Point -->
                    <circle cx="8" cy="10" r="1.5" fill="#f7b047"/> <!-- Data Point -->
                    <circle cx="12" cy="15" r="1.5" fill="#f7b047"/> <!-- Data Point -->
                    <circle cx="17" cy="8" r="1.5" fill="#f7b047"/> <!-- Data Point -->
                    <circle cx="20" cy="12" r="1.5" fill="#f7b047"/> <!-- Data Point -->
                  </svg>`;
                  iconElement.onclick = function (event) {
                    setAnchorEl(event.currentTarget as HTMLSpanElement);
                    setMapChart(true);
                    setMapChartData(
                      JSON.parse(feature.properties["disasterPred"])
                        .month_prediction
                    );
                  };
                  placeholder.appendChild(iconElement);
                }
              }, 100);

              infoWindow.setContent(infoWindowContent);
              infoWindow.setPosition(centroid);
              infoWindow.open(map);
            });
          });
          const mapLayout: any = generateDataRange(stateData, type,geoData);
          const latitude = mapLayout.latitude;
          const longitude = mapLayout.longitude;

          map.setCenter(new google.maps.LatLng(latitude, longitude));
        }
      }

      if (!checked) {
        if (newCenter) {
          removeMarkers(map);
          removeGeoLocations(map);
          removeListeners(map);
          map.setCenter(newCenter);
          map.setZoom(newZoom);
          // dispatch({
          //   type: "APPLY_FILTER",
          //   payload: {
          //     ...state?.filters,
          //     heatMapCenter: mapCenter,
          //     heatMapZoom:mapZoom
          //   },
          // });
        } else {
          removeMarkers(map);
          removeGeoLocations(map);
          removeListeners(map);
          const mapLayout = generateDataRange(stateData, mapType,geoData);
          const latitude = mapLayout.latitude;
          const longitude = mapLayout.longitude;
          const getlat = () => {
            if (state.filters.heatMapCenter.lat != "") {
              return state.filters.heatMapCenter.lat.toString();
            }
            return latitude;
          };
          const getLng = () => {
            if (state.filters.heatMapCenter.lng != "") {
              return state.filters.heatMapCenter.lng.toString();
            }
            return longitude;
          };
          // map.setCenter(new google.maps.LatLng(getlat(), getLng()))
        }
        // const mapLayout = generateDataRange(stateData, mapType);
        // const latitude = mapLayout.latitude;
        // const longitude = mapLayout.longitude;
        // const getlat = () => {
        //   if (state.filters.heatMapCenter.lat != "") {
        //     return state.filters.heatMapCenter.lat.toString();
        //   }
        //   return latitude;
        // };
        // const getLng = () => {
        //   if (state.filters.heatMapCenter.lng != "") {
        //     return state.filters.heatMapCenter.lng.toString();
        //   }
        //   return longitude;
        // };
      }

      //   if (state.filters.showFireMap && layerLoad) {
      //     setLayerLoading(true);
      //     const dist = new Set();
      //     const bounds = new google.maps.LatLngBounds();
      //     const pageSize = 500; // Define the chunk size
      //     let allData:any = []; // Array to hold all the data from all pages
      //     let isFetching = false; // Flag to prevent multiple fetchAllPages calls

      //     const drawPolygon = (coordinates:any, properties:any) => {
      //         const polygon = new google.maps.Polygon({
      //             paths: coordinates,
      //             strokeColor: properties.stroke || 'white',
      //             strokeOpacity: properties['stroke-opacity'] || 0.8,
      //             strokeWeight: 1.5,
      //             fillColor: properties.fill || 'orange',
      //             fillOpacity: properties['fill-opacity'] || 0.3,
      //             map: map,
      //         });

      //         const infoWindowContent = `
      //             <div id='map-tooltip'>
      //               <div class='nav-bar'>
      //                 <div class='nav-title'>
      //                   <span>Hazard Data</span>
      //                 </div>
      //               </div>
      //               <div class='nav-container'>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Responsibility Area:</div>
      //                   <div class='nav-container-value'>${properties['SRA'] || 'N/A'}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Hazard Code:</div>
      //                   <div class='nav-container-value'>${properties['HAZ_CODE'] || 'N/A'}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Hazard Class:</div>
      //                   <div class='nav-container-value'>${properties['HAZ_CLASS'] || 'N/A'}</div>
      //                 </div>
      //               </div>
      //             </div>
      //           `;

      //         polygon.addListener("click", () => {
      //             if (popup) {
      //                 popup.close();
      //             }
      //             infoWindow.setContent(infoWindowContent);
      //             infoWindow.setPosition(coordinates[0]);
      //             infoWindow.open(map);
      //         });
      //     };

      //     const fetchPageData = async (page:any) => {
      //         const response = await fetch(
      //             `https://realstate-api.service.dev.slate.ai/realestate/v1/getFireCoordinatesBySeverity?state=California&category=all&page=${page}&size=${pageSize}`
      //         );
      //         const data = await response.json();
      //         return data;
      //     };

      //     const fetchAllPages = async () => {
      //         if (isFetching) return;
      //         isFetching = true;

      //         try {
      //             const initialData = await fetchPageData(0);
      //             const totalPages = initialData.totalPages;

      //             const fetchAndProcessPage = async (page:any) => {
      //                 try {
      //                     const data = await fetchPageData(page);
      //                     if (data.cube && Array.isArray(data.cube)) {
      //                         allData = allData.concat(data.cube); // Append to allData
      //                         data.cube.forEach(feature => {
      //                             const properties = JSON.parse(feature.properties);
      //                             try {
      //                                 const rawCoordinates = JSON.parse(feature.coordinates);

      //                                 rawCoordinates.forEach(polygon => {
      //                                     const formattedCoordinates = polygon.map(([lng, lat]) => {
      //                                         const parsedLat = parseFloat(lat);
      //                                         const parsedLng = parseFloat(lng);

      //                                         if (isNaN(parsedLat) || isNaN(parsedLng)) {
      //                                             console.warn("Invalid coordinates detected, skipping:", { lat, lng });
      //                                             return null;
      //                                         }

      //                                         return { lat: parsedLat, lng: parsedLng };
      //                                     }).filter(coord => coord !== null);

      //                                     if (formattedCoordinates.length > 0) {
      //                                         formattedCoordinates.forEach(coord => bounds.extend(coord));
      //                                         if (properties['SRA']) {
      //                                             dist.add(properties['SRA']);
      //                                         }
      //                                         drawPolygon(formattedCoordinates, properties);
      //                                     }
      //                                 });
      //                             } catch (parseError) {
      //                                 console.error("Error parsing coordinates:", parseError);
      //                             }
      //                         });
      //                     }
      //                 } catch (error) {
      //                     console.error(`Error fetching page ${page}:`, error);
      //                 }
      //             };

      //             // Create batches of pages to fetch concurrently
      //             const batchSize = 5; // Number of pages to fetch concurrently
      //             for (let page = 1; page <= totalPages; page += batchSize) {
      //                 const batchPromises = [];
      //                 for (let i = page; i < page + batchSize && i <= totalPages; i++) {
      //                     batchPromises.push(fetchAndProcessPage(i));
      //                 }
      //                 await Promise.all(batchPromises);
      //             }

      //             console.log("All data loaded.");
      //             setLayerLoading(false);
      //         } catch (error) {
      //             console.error("Error fetching or processing data:", error);
      //             setLayerLoading(false);
      //         } finally {
      //             isFetching = false;
      //         }
      //     };

      //     // Start fetching all pages
      //     fetchAllPages();
      // }

      // if (state.filters.showFireMap && layerLoad) {
      //   setLayerLoading(true);
      //   const dist = new Set();
      //   const bounds = new google.maps.LatLngBounds();
      //   const pageSize = 500; // Define the chunk size
      //   let allData:any = []; // Array to hold all the data from all pages

      //   const drawPolygon = (coordinates:any, properties:any) => {
      //     const polygon = new google.maps.Polygon({
      //       paths: coordinates,
      //       strokeColor: properties.stroke || 'white',
      //       strokeOpacity: properties['stroke-opacity'] || 0.8,
      //       strokeWeight: 1.5,
      //       fillColor: properties.fill || 'orange',
      //       fillOpacity: properties['fill-opacity'] || 0.3,
      //       map: map,
      //     });

      //     const infoWindowContent = `
      //       <div id='map-tooltip'>
      //         <div class='nav-bar'>
      //           <div class='nav-title'>
      //             <span>Hazard Data</span>
      //           </div>
      //         </div>
      //         <div class='nav-container'>
      //           <div class='nav-container-col'>
      //             <div class='nav-container-title'>Responsibility Area:</div>
      //             <div class='nav-container-value'>${properties['SRA'] || 'N/A'}</div>
      //           </div>
      //           <div class='nav-container-col'>
      //             <div class='nav-container-title'>Hazard Code:</div>
      //             <div class='nav-container-value'>${properties['HAZ_CODE'] || 'N/A'}</div>
      //           </div>
      //           <div class='nav-container-col'>
      //             <div class='nav-container-title'>Hazard Class:</div>
      //             <div class='nav-container-value'>${properties['HAZ_CLASS'] || 'N/A'}</div>
      //           </div>
      //         </div>
      //       </div>
      //     `;

      //     polygon.addListener("click", () => {
      //       if (popup) {
      //         popup.close();
      //       }
      //       infoWindow.setContent(infoWindowContent);
      //       infoWindow.setPosition(coordinates[0]);
      //       infoWindow.open(map);
      //     });
      //   };

      //   const fetchAllPages = async () => {
      //     try {
      //       // First, make an initial request to get total pages
      //       const initialResponse = await fetch(
      //         `https://realstate-api.service.dev.slate.ai/realestate/v1/getFireCoordinatesBySeverity?state=California&category=all&page=0&size=${pageSize}`
      //       );
      //       const initialData = await initialResponse.json();
      //       const totalPages = initialData.totalPages;

      //       // Create an array of fetch promises for all pages
      //       const fetchPromises = [];
      //       for (let page = 1; page <= totalPages; page++) {
      //         fetchPromises.push(
      //           fetch(`https://realstate-api.service.dev.slate.ai/realestate/v1/getFireCoordinatesBySeverity?state=California&category=all&page=${page}&size=${pageSize}`)
      //             .then(response => response.json())
      //         );
      //       }

      //       // Execute all fetches in parallel
      //       const results = await Promise.all(fetchPromises);

      //       console.log(results)

      //       // Combine all the data into a single array
      //       results.forEach(data => {
      //         if (data.cube && Array.isArray(data.cube)) {
      //           allData = allData.concat(data.cube); // Append each 'cube' array to allData
      //         }
      //       });

      //       console.log(allData)

      //       // Process all data and draw on the map
      //       allData.forEach(feature => {
      //         const properties = JSON.parse(feature.properties); // Parse properties JSON string
      //         try {
      //           const rawCoordinates = JSON.parse(feature.coordinates); // Parse coordinates array

      //           rawCoordinates.forEach(polygon => {
      //             const formattedCoordinates = polygon.map(([lng, lat]) => {
      //               const parsedLat = parseFloat(lat);
      //               const parsedLng = parseFloat(lng);

      //               // Validate the parsed latitude and longitude
      //               if (isNaN(parsedLat) || isNaN(parsedLng)) {
      //                 console.warn("Invalid coordinates detected, skipping:", { lat, lng });
      //                 return null; // Skip invalid coordinates
      //               }

      //               return { lat: parsedLat, lng: parsedLng }; // Convert to Google Maps format
      //             }).filter(coord => coord !== null); // Remove any invalid coordinates

      //             if (formattedCoordinates.length > 0) {
      //               formattedCoordinates.forEach(coord => bounds.extend(coord)); // Extend map bounds
      //               if (properties['SRA']) {
      //                 dist.add(properties['SRA']);
      //               }
      //               drawPolygon(formattedCoordinates, properties); // Draw the polygon on the map
      //             }
      //           });
      //         } catch (parseError) {
      //           console.error("Error parsing coordinates:", parseError);
      //         }
      //       });

      //       console.log("All data loaded.");
      //       setLayerLoading(false);
      //     } catch (error) {
      //       console.error("Error fetching or processing data:", error);
      //       setLayerLoading(false);
      //     }
      //   };

      //   // Start fetching all pages at once
      //   fetchAllPages();
      // }

      // if (state.filters.showFireMap && layerLoad) {
      //   setLayerLoading(true);
      //   const dist = new Set()
      //   fetch('/California_Fire/fire_data.zip') // Fetch the ZIP file
      //     .then((response) => response.arrayBuffer()) // Convert to ArrayBuffer
      //     .then(async (zipData) => {
      //       const zip:any = await JSZip.loadAsync(zipData); // Load the ZIP file with JSZip

      //       // Filter for GeoJSON files
      //       const geojsonFiles = Object.keys(zip.files).filter((fileName) => fileName.endsWith('.json'));
      //       console.log(geojsonFiles)

      //       if (geojsonFiles.length === 0) {
      //         throw new Error("No GeoJSON files found in the ZIP archive.");
      //       }

      //       const bounds = new google.maps.LatLngBounds();

      //       const drawPolygon = (coordinates: any, properties: any) => {
      //         const polygon = new google.maps.Polygon({
      //           paths: coordinates,
      //           strokeColor: 'white', // Border color
      //           strokeOpacity: 0.8, // Border opacity
      //           strokeWeight: 1.5, // Border thickness
      //           fillColor: 'red', // Fill color of the polygon
      //           fillOpacity: 0.3, // Opacity of the shaded region
      //           strokePattern: [
      //             // Create a line texture with a dash pattern
      //             { icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 2 }, repeat: '20px' },
      //           ],
      //           map: map, // Your Google Map instance
      //         });

      //         // Create InfoWindow content
      //         const infoWindowContent = `
      //           <div id='map-tooltip'>
      //           <div class='nav-bar'>
      //             <div class='nav-title'>
      //               <span>Hazard Data</span>
      //             </div>
      //           </div>
      //           <div class='nav-container'>
      //             <div class='nav-container-col'>
      //               <div class='nav-container-title'>Responsibility Area:</div>
      //               <div class='nav-container-value'>${properties['SRA'] || 'N/A'}</div>
      //             </div>

      //             <div class='nav-container-col'>
      //               <div class='nav-container-title'>Hazard Code:</div>
      //               <div class='nav-container-value'>${properties['HAZ_CODE'] || 'N/A'}</div>
      //             </div>
      //             <div class='nav-container-col'>
      //               <div class='nav-container-title'>Hazard Class:</div>
      //               <div class='nav-container-value'>${properties['HAZ_CLASS'] || 'N/A'}</div>
      //             </div>
      //           </div>
      //         </div>
      //         `;

      //         // Create InfoWindow

      //         // Add click event listener to open InfoWindow
      //         polygon.addListener("click", () => {
      //           // Close the currently open InfoWindow if it exists

      //           if(popup){
      //             popup.close()
      //           }
      //            infoWindow.setContent(infoWindowContent);

      //           // Set the position and open the new InfoWindow
      //           infoWindow.setPosition(coordinates[0]); // Set to the first coordinate point
      //           infoWindow.open(map);
      //         });
      //       };

      //       // Process each GeoJSON file
      //       for (const fileName of geojsonFiles) {
      //         const geojsonText = await zip.file(fileName).async("text"); // Extract GeoJSON content
      //         const geojsonData = JSON.parse(geojsonText); // Parse GeoJSON data

      //         // Check for GeoJSON type
      //         if (geojsonData.type === "FeatureCollection") {
      //           geojsonData.features.forEach((feature:any) => {
      //             const { geometry, properties } = feature;

      //               if (geometry.type === "Polygon") {
      //                 // Process Polygon
      //                 geometry.coordinates.forEach((polygon:any) => {
      //                   const coordinates = polygon.map(([lng, lat]:any) => ({
      //                     lat,
      //                     lng,
      //                   }));

      //                   // Extend map bounds to include the coordinates
      //                   coordinates.forEach((coord:any) => bounds.extend(coord));
      //                   if (properties["SRA"]) {
      //                     dist.add(properties["SRA"]);
      //                   }

      //                   drawPolygon(coordinates, properties);
      //                 });
      //               } else if (geometry.type === "MultiPolygon") {
      //                 // Process MultiPolygon
      //                 geometry.coordinates.forEach((multiPolygon:any) => {
      //                   multiPolygon.forEach((polygon:any) => {
      //                     const coordinates = polygon.map(([lng, lat]:any) => ({
      //                       lat,
      //                       lng,
      //                     }));

      //                     // Extend map bounds to include the coordinates
      //                     coordinates.forEach((coord:any) => bounds.extend(coord));

      //                     drawPolygon(coordinates, properties);
      //                   });
      //                 });
      //               } else {
      //                 console.warn(`Unsupported GeoJSON geometry type: ${geometry.type}`);
      //               }

      //           });
      //         } else {
      //           console.warn(`Unsupported GeoJSON type: ${geojsonData.type}`);
      //         }

      //       }
      //       console.log("Distinct FLD_ZONE values:", Array.from(dist));

      //       // Adjust map view to fit the bounds
      //       // map.fitBounds(bounds);
      //       setLayerLoading(false);
      //     })
      //     .catch((error) => {
      //       console.log("Distinct FLD_ZONE values:", Array.from(dist));
      //       console.error("Error fetching or processing ZIP file:", error);
      //       setLayerLoading(false);
      //     });
      // }

      // if (state.filters.showFireMap) {
      //   setLayerLoading(true);
      //   const dataLayer = new google.maps.Data();

      //   // const promises = California_Fire_Names.map((name) => {
      //   //   const URL = "/California_Fire GEO/" + name + ".geojson";
      //   //   console.log(URL)
      //   //   fetch(URL)
      //   //   .then((response) => response.json())
      //   //   .then((geoJson) => {
      //   //     // Add the GeoJSON to the map
      //   //     dataLayer.addGeoJson(geoJson);
      //   //     dataLayer.setMap(map);

      //   //     // Fit the map to the bounds of the GeoJSON
      //   //     const bounds = new google.maps.LatLngBounds();
      //   //     dataLayer.forEach((feature:any) => {
      //   //       feature.getGeometry().forEachLatLng((latLng:any) => {
      //   //         bounds.extend(latLng);
      //   //       });
      //   //     });
      //   //     dataLayer.setStyle((feature: { getProperty: (arg0: string) => any }) => {
      //   //       return {
      //   //         // @ts-ignore
      //   //         fillColor: 'blue',
      //   //         strokeWeight: 1,
      //   //         fillOpacity: 1,
      //   //       };
      //   //     });

      //   //     dataLayer.addListener('click', (event: any) => {
      //   //       const properties = event.feature
      //   //       const extendedData = {
      //   //         SRA: properties.SRA,
      //   //         INCORP: properties.INCORP,
      //   //         HAZ_CODE: properties.HAZ_CODE,
      //   //         HAZ_CLASS: properties.HAZ_CLASS,
      //   //         Shape_Leng: properties.Shape_Leng,
      //   //         Shape_Area: properties.Shape_Area,
      //   //       };

      //   //       const infoWindowContent = `
      //   //         <div id='map-tooltip'>
      //   //           <div class='nav-bar'>
      //   //             <div class='nav-title'>
      //   //               <span>Hazard Data</span>
      //   //             </div>
      //   //           </div>
      //   //           <div class='nav-container'>
      //   //             <div class='nav-container-col'>
      //   //               <div class='nav-container-title'>SRA:</div>
      //   //               <div class='nav-container-value'>${extendedData.SRA || "N/A"}</div>
      //   //             </div>
      //   //             <div class='nav-container-col'>
      //   //               <div class='nav-container-title'>Incorporated:</div>
      //   //               <div class='nav-container-value'>${extendedData.INCORP || "N/A"}</div>
      //   //             </div>
      //   //             <div class='nav-container-col'>
      //   //               <div class='nav-container-title'>Hazard Code:</div>
      //   //               <div class='nav-container-value'>${extendedData.HAZ_CODE || "N/A"}</div>
      //   //             </div>
      //   //             <div class='nav-container-col'>
      //   //               <div class='nav-container-title'>Hazard Class:</div>
      //   //               <div class='nav-container-value'>${extendedData.HAZ_CLASS || "N/A"}</div>
      //   //             </div>
      //   //             <div class='nav-container-col'>
      //   //               <div class='nav-container-title'>Shape Length:</div>
      //   //               <div class='nav-container-value'>${extendedData.Shape_Leng || "N/A"}</div>
      //   //             </div>
      //   //             <div class='nav-container-col'>
      //   //               <div class='nav-container-title'>Shape Area:</div>
      //   //               <div class='nav-container-value'>${extendedData.Shape_Area || "N/A"}</div>
      //   //             </div>
      //   //           </div>
      //   //         </div>
      //   //       `;

      //   //       const infoWindow = new google.maps.InfoWindow({
      //   //         content: infoWindowContent,
      //   //         position: event.latLng,
      //   //       });

      //   //       infoWindow.open(map);
      //   //     });
      //   //     // map.fitBounds(bounds);
      //   //     // setLayerLoading(false)
      //   //   })
      //   //   .catch((error) => {
      //   //     console.error('Error loading GeoJSON:', error);
      //   //     // setLayerLoading(false)
      //   //   });

      //   // })
      //   // Promise.all(promises)
      //   // .then(() => {
      //   //   console.log('all')
      //   //   setLayerLoading(false);
      //   // })
      //   // .catch((error) => {
      //   //   console.error("Error processing KML files:", error);
      //   //   setLayerLoading(false); // Ensure the loader is turned off even if there's an error
      //   // });

      //   const promises = California_Fire_Names.map((name) => {
      //     const URL = "/California_Fire/" + name + ".kml";
      //     console.log(name)
      //     return fetch(URL)
      //       .then((response) => response.text())
      //       .then((kmltext) => {
      //         const parser = new DOMParser();
      //         const kmlDoc = parser.parseFromString(kmltext, "text/xml");

      //         // Extract placemarks and add markers
      //         const placemarks = kmlDoc.getElementsByTagName("Placemark");
      //         const bounds = new google.maps.LatLngBounds();
      //         for (let i = 0; i < placemarks.length; i++) {
      //           const placemark = placemarks[i];

      //           // Extract coordinates
      //           const coordinatesElement = placemark.getElementsByTagName("coordinates")[0];
      //           if (!coordinatesElement) {
      //             console.warn(`No coordinates found for placemark index ${i}`);
      //             continue; // Skip this placemark if no coordinates are found
      //           }

      //           const coordinatesText = coordinatesElement.textContent || '';
      //           const coordinates = coordinatesText
      //             .trim()
      //             .split(" ")
      //             .map((coord) => {
      //               const [lng, lat] = coord.split(",");
      //               return { lat: parseFloat(lat), lng: parseFloat(lng) };
      //             });
      //           coordinates.forEach((coord) => bounds.extend(coord));

      //           // Extract extended data
      //           const extendedData:any = {};
      //           const simpleDataElements = placemark.getElementsByTagName("SimpleData");
      //           for (let j = 0; j < simpleDataElements.length; j++) {
      //             const name:any = simpleDataElements[j].getAttribute("name");
      //             const value = simpleDataElements[j].textContent;
      //             extendedData[name] = value;
      //           }

      //           // Create polygon
      //           const polygon = new google.maps.Polygon({
      //             paths: coordinates,
      //             strokeColor: 'white',
      //             strokeOpacity: 0.8,
      //             strokeWeight: 0.8,
      //             fillColor: 'orange',
      //             fillOpacity: 0.35,
      //             map: map, // Your Google Map instance
      //           });

      //           // Create InfoWindow content
      //           const infoWindowContent = `
      //             <div id='map-tooltip'>
      //               <div class='nav-bar'>
      //                 <div class='nav-title'>
      //                   <span>Hazard Data</span>
      //                 </div>
      //               </div>
      //               <div class='nav-container'>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>SRA:</div>
      //                   <div class='nav-container-value'>${extendedData['SRA']}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Incorporated:</div>
      //                   <div class='nav-container-value'>${extendedData['INCORP']}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Hazard Code:</div>
      //                   <div class='nav-container-value'>${extendedData['HAZ_CODE']}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Hazard Class:</div>
      //                   <div class='nav-container-value'>${extendedData['HAZ_CLASS']}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Shape Length:</div>
      //                   <div class='nav-container-value'>${parseFloat(
      //                     parseFloat(extendedData['Shape_Leng']).toFixed(2)
      //                   )}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Shape Area:</div>
      //                   <div class='nav-container-value'>${parseFloat(
      //                     parseFloat(extendedData['Shape_Area']).toFixed(2)
      //                   )}</div>
      //                 </div>
      //               </div>
      //             </div>
      //           `;

      //           // Create InfoWindow
      //           const infoWindow = new google.maps.InfoWindow({
      //             content: infoWindowContent,
      //           });

      //           // Add click event listener to open InfoWindow
      //           polygon.addListener("click", () => {
      //             infoWindow.setPosition(coordinates[0]); // Set to the first coordinate point
      //             infoWindow.open(map);
      //           });
      //         }
      //         // map.fitBounds(bounds);
      //       })
      //       .catch((error) => {
      //         console.error("Error loading KML file:", error);
      //       });
      //   });

      //   Promise.all(promises)
      //     .then(() => {
      //       setLayerLoading(false);
      //     })
      //     .catch((error) => {
      //       console.error("Error processing KML files:", error);
      //       setLayerLoading(false); // Ensure the loader is turned off even if there's an error
      //     });
      // }

      // if (state.filters.showFireMap) {
      //       setLayerLoading(true);
      //       fetch('/California_Fire/output.zip') // Fetch the ZIP file
      //         .then((response) => response.arrayBuffer()) // Convert to ArrayBuffer
      //         .then(async (zipData) => {
      //           const zip:any= await JSZip.loadAsync(zipData); // Load the ZIP file with JSZip

      //           const kmlFile = Object.keys(zip.files).find((fileName) => fileName.endsWith('.kml'));

      //           if (!kmlFile) {
      //             throw new Error("KML file not found in the ZIP archive.");
      //           }

      //           // Extract KML file content as text
      //           const kmlText = await zip.file(kmlFile).async("text");
      //           const parser = new DOMParser();
      //           const kmlDoc = parser.parseFromString(kmlText, "text/xml");

      //           // Extract placemarks and add markers
      //           const placemarks = kmlDoc.getElementsByTagName("Placemark");
      //           const bounds = new google.maps.LatLngBounds();
      //           const extractedData = [];

      //           for (let i = 0; i < placemarks.length; i++) {
      //             const placemark = placemarks[i];

      //             // Extract coordinates
      //             const coordinatesElement = placemark.getElementsByTagName("coordinates")[0];
      //             if (!coordinatesElement) {
      //               console.warn(`No coordinates found for placemark index ${i}`);
      //               continue; // Skip this placemark if no coordinates are found
      //             }

      //             const coordinatesText = coordinatesElement.textContent || '';
      //             const coordinates = coordinatesText.trim().split(" ").map((coord) => {
      //               const [lng, lat] = coord.split(",");
      //               return { lat: parseFloat(lat), lng: parseFloat(lng) };
      //             });
      //             coordinates.forEach((coord) => bounds.extend(coord));

      //             // Extract extended data
      //             const extendedData:any = {};
      //             const simpleDataElements = placemark.getElementsByTagName("SimpleData");
      //             for (let j = 0; j < simpleDataElements.length; j++) {
      //               const name:any = simpleDataElements[j].getAttribute("name");
      //               const value = simpleDataElements[j].textContent;
      //               extendedData[name] = value;
      //             }
      //             extractedData.push({ coordinates, extendedData });

      //               const polygon = new google.maps.Polygon({
      //                 paths: coordinates,
      //                 strokeColor: 'white',
      //                 strokeOpacity: 0.8,
      //                 strokeWeight: 0.8,
      //                 fillColor: 'red',
      //                 fillOpacity: 0.2,
      //                 map: map, // Your Google Map instance
      //               });

      //               // Create InfoWindow content
      //               const infoWindowContent = `
      //               <div id='map-tooltip'>
      //               <div class='nav-bar'>
      //                 <div class='nav-title'>
      //                   <span>Hazard Data</span>
      //                 </div>
      //               </div>
      //               <div class='nav-container'>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>SRA:</div>
      //                   <div class='nav-container-value'>${extendedData['SRA']}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Layer:</div>
      //                   <div class='nav-container-value'>${extendedData['layer']}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Hazard Code:</div>
      //                   <div class='nav-container-value'>${extendedData['HAZ_CODE']}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Hazard Class:</div>
      //                   <div class='nav-container-value'>${extendedData['HAZ_CLASS']}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Shape Length:</div>
      //                   <div class='nav-container-value'>${extendedData['Shape_Leng']}</div>
      //                 </div>
      //                 <div class='nav-container-col'>
      //                   <div class='nav-container-title'>Shape Area:</div>
      //                   <div class='nav-container-value'>${extendedData['Shape_Area']}</div>
      //                 </div>
      //               </div>
      //             </div>
      //               `;

      //               // Create InfoWindow
      //               const infoWindow = new google.maps.InfoWindow({
      //                 content: infoWindowContent,
      //               });

      //               // Add click event listener to open InfoWindow
      //               polygon.addListener("click", () => {
      //                 infoWindow.setPosition(coordinates[0]); // Set to the first coordinate point
      //                 infoWindow.open(map);
      //               });

      //             // Create polygon

      //           }

      //           // Adjust map view to fit the bounds
      //           // map.fitBounds(bounds);
      //           setLayerLoading(false);
      //           console.log(extractedData);
      //         })
      //         .catch((error) => {
      //           console.error("Error fetching or processing ZIP file:", error);
      //           setLayerLoading(false);
      //         });
      //     }

      // Helper function to draw polygon
    };

    drawMap(
      map,
      stateData,
      geoData,
      mapType,
      table,
      title,
      true,
      true,
      showHeatMap
    );

    //  else{
    //   const mapLayout = generateDataRange(stateData, mapType);
    //   const latitude = mapLayout.latitude;
    //   const longitude = mapLayout.longitude;
    //   const getlat = () => {
    //     if (state.filters.heatMapCenter.lat != "") {
    //       return state.filters.heatMapCenter.lat.toString();
    //     }
    //     return latitude;
    //   };
    //   const getLng = () => {
    //     if (state.filters.heatMapCenter.lng != "") {
    //       return state.filters.heatMapCenter.lng.toString();
    //     }
    //     return longitude;
    //   };
    //   map.setCenter(new google.maps.LatLng(getlat(), getLng()));
    //  }
  }, []);

  const handleChange = (event: any, newMapType: any) => {
    console.log(newMapType);

    if (newMapType !== null) {
      setMapType(newMapType);
      Hmap.setMapTypeId(newMapType);
      const legendTitle = document.getElementById("title");
      const barDiv = document.getElementById("legend-range");

      // Change the color of the legend title based on the new map type
      if (legendTitle && barDiv && newMapType === "hybrid") {
        legendTitle.style.color = "white";
        barDiv.style.color = "white";
      } else if (legendTitle && barDiv && newMapType != "hybrid") {
        legendTitle.style.color = "black";
        barDiv.style.color = "black";
      }
      // onMapTypeChange(newMapType);
    }
  };

  const riskContent: any = {
    "0": {
      title: "0 - No Risk",
      description:
        "Areas with an inundation risk rating of 0 are considered to have no significant risk of flooding. These areas are typically located well above known flood zones, far from water bodies, or in regions where historical data shows no significant flooding events.",
      implications:
        "Little to no concern for flooding, and standard property insurance usually suffices without additional flood insurance.",
    },
    "1": {
      title: "1 - Low Risk",
      description:
        "Areas with a rating of 1 have a low risk of flooding. This might include areas near water bodies but with protective infrastructure like levees or areas with a low probability of flooding based on historical data.",
      implications:
        "Flooding is unlikely, but not impossible. Property owners might consider basic flood insurance, particularly if the property value is high or there is concern about climate change.",
    },
    "2": {
      title: "2 - Moderate Risk",
      description:
        "A rating of 2 indicates a moderate risk of inundation. These areas are more prone to flooding, possibly located in floodplains or near rivers, lakes, or coasts with a history of occasional flooding events.",
      implications:
        "Flood insurance is strongly recommended. Property owners should also consider taking protective measures, such as installing flood barriers or elevating structures where possible.",
    },
    "3": {
      title: "3 - High Risk",
      description:
        "Areas with a rating of 3 are considered high-risk zones for inundation. These regions are often located in floodplains, coastal areas, or regions with a history of frequent or severe flooding. This rating might also apply to areas with poor drainage systems or those vulnerable to storm surges and rising sea levels.",
      implications:
        "Flood insurance is often mandatory in these areas. Property owners should take significant precautions, such as elevating buildings, improving drainage, and having an emergency plan in place.",
    },
  };
  const floodContent: any = {
    VE: {
      description:
        "Flood Zone VE: Areas are subject to both storm surge and high-velocity wave action in coastal regions. Building codes in these zones are stricter to protect structures from both flooding and wave forces, and flood insurance is typically required. VE zones are considered some of the most hazardous flood zones, particularly along coastlines.",
    },
    AO: {
      description:
        "Flood Zone AO:  Areas with a moderate risk of shallow flooding, typically caused by sheet flow or ponding. Properties in these zones must meet specific elevation requirements to reduce flood risk, and flood insurance is mandatory. The depth of flooding (usually 1-3 feet) is the primary factor for determining construction requirements and flood insurance rates in these zones.Areas with a rating of 1 have a low risk of flooding. This might include areas near water bodies but with protective infrastructure like levees or areas with a low probability of flooding based on historical data.",
    },
    A: {
      description:
        "Flood Zone A: A high-risk area with a 1% chance of flooding each year and a 26% chance of flooding over the course of a 30-year  mortgage, but nodetailed study has been conducted to determine Base Flood Elevations.ting of 2 indicates a moderate risk of inundation. These areas are more prone to flooding, possibly located in floodplains or near rivers, lakes, or coasts with a history of occasional flooding events.",
    },
    AE: {
      description:
        "Flood Zone AE high-risk area with a 1% chance of flooding each year and a 26% chance of flooding over the course of a 30-year mortgage.",
    },
    X: {
      description:
        "Flood Zone X: This represents areas of moderate flood risk. Specifically, it refers to areas that are outside the 1% annual chance floodplain (the 100-year floodplain) but inside the 0.2% annual chance floodplain (the 500-year floodplain).",
    },
    OW: {
      description:
        'Flood Zone OW: "OW" is classified as "Open Water," indicating that the area is either underwater or is a body of water itself, such as a lake, river, or ocean. These areas are naturally prone to flooding and might not be subject to typical floodplain management rules because they are permanently or seasonally water-covered.',
    },
  };
  const fireContent: any = {
    LRA: {
      description:
        "LRA (Local Responsibility Area) refers to areas in California where local governments (such as city or county fire departments) are responsible for fire protection prevention. These areas are typically more urbanized or developed than State Responsibility Areas (SRA) and tend to include cities, suburbs, and other areas under local jurisdiction.",
    },
    SRA: {
      description:
        "SRA (State Responsibility Area) refers to areas in California where the state government, primarily through the California Department of Forestry and Fire Protection (CAL FIRE), is responsible for wildfire prevention and suppression. SRA designations are used in fire hazard planning and are an important component in understanding fire risk zones.",
    },
    FRA: {
      description:
        "FRA (Federal Responsibility Area) refers to areas in California where the federal government is responsible for fire protection, prevention, and suppression. These areas typically include federal lands such as national forests, national parks, military bases, and other lands managed by federal agencies like the U.S. Forest Service (USFS),Bureau of Land Management (BLM),National Park Service (NPS), or the Department of Defense.",
    },
  };
  const floodSubtypeContent: any = {
    "AREA OF MINIMAL FLOOD HAZARD": {
      description:
        "AREA OF MINIMAL FLOOD HAZARD: Areas with minimal flood risk, generally outside the Special Flood Hazard Area (SFHA) and beyond the 0.2% annual chance floodplain. These areas have a low probability of flooding and are typically designated as Zone X (Unshaded) on FEMA Flood Insurance Rate Maps (FIRMs).",
    },
    "0.2 PCT ANNUAL CHANCE FLOOD HAZARD": {
      description:
        "0.2 PCT ANNUAL CHANCE FLOOD HAZARD: Areas with a 0.2% annual chance of flooding, also known as the 500-year floodplain. These areas have a moderate flood risk but are not considered high-risk by FEMA standards. Typically, they are designated as Shaded Zone X on FIRMs.",
    },
    "COASTAL FLOODPLAIN": {
      description:
        "COASTAL FLOODPLAIN: Areas in coastal regions that have a 1% or greater annual chance of flooding with additional hazards such as storm-induced waves. It includes areas designated as Zones V, VE, or Coastal AE on FEMA maps, indicating high-risk areas with storm surge and wave action hazards.",
    },
    "RIVERINE FLOODWAY IN COMBINED RIVERINE AND COASTAL ZONE": {
      description:
        "RIVERINE FLOODWAY IN COMBINED RIVERINE AND COASTAL ZONE: Areas that lie in both riverine flood zones (inland water bodies like rivers and streams) and coastal flood zones. The 'floodway' component indicates areas where water flows during a flood event and is subject to stringent development restrictions due to the potential for significant flooding.",
    },
    "COMBINED RIVERINE AND COASTAL FLOODPLAIN": {
      description:
        "COMBINED RIVERINE AND COASTAL FLOODPLAIN: Areas exposed to flooding risks from both inland rivers and coastal sources. It includes floodplains where both riverine and coastal flooding hazards overlap, which can lead to compounded flooding risks.",
    },
    "0.2 PCT ANNUAL CHANCE FLOOD HAZARD IN COASTAL ZONE": {
      description:
        "0.2 PCT ANNUAL CHANCE FLOOD HAZARD IN COASTAL ZONE: Areas in coastal zones with a 0.2% annual chance of flooding (500-year floodplain). These areas face moderate flood risks primarily due to coastal storms, high tides, or waves.",
    },
    "0.2 PCT ANNUAL CHANCE FLOOD HAZARD IN COMBINED RIVERINE": {
      description:
        "0.2 PCT ANNUAL CHANCE FLOOD HAZARD IN COMBINED RIVERINE: Areas in the combined riverine and coastal floodplain that have a 0.2% annual chance of flooding (500-year floodplain). The combined risk from both riverine and coastal sources makes these areas prone to moderate flooding events.",
    },
    FLOODWAY: {
      description:
        "FLOODWAY: The floodway is the channel of a river or other watercourse and the adjacent land areas that must be reserved to discharge the base flood (usually the 1% annual chance flood or 100-year flood) without cumulatively increasing the water surface elevation more than a designated height. Development is generally restricted in floodways to minimize obstruction and maintain natural water flow.",
    },
    "2000": {
      description:
        "This value is not a standard FEMA flood zone designation and could represent an internal or project-specific code related to a certain type of flood hazard or risk area.",
    },
    "0500": {
      description:
        "This value is not a standard FEMA flood zone designation and may indicate a specific classification or code used by a particular organization or dataset to categorize flood hazards.",
    },
    "1100": {
      description:
        "This value is also not a standard FEMA flood zone designation and may serve as a unique identifier or code for a flood risk type in a specific context or system.",
    },
  };
  const hucDescriptions: any = {
    "03070205": {
      description:
        "03: South Atlantic-Gulf Region (major river systems that drain into the Atlantic and Gulf of Mexico).\n07: Subregion within the South Atlantic-Gulf, specifically related to the Apalachicola-Chattahoochee-Flint (ACF) River Basin.\n02: Accounting unit for smaller drainage areas within this river basin.\n05: Sub-basin, likely referring to a specific watershed within the ACF basin.",
    },
    "03070204": {
      description:
        "03: South Atlantic-Gulf Region (major river systems that drain into the Atlantic and Gulf of Mexico).\n07: Subregion within the South Atlantic-Gulf, specifically related to the Apalachicola-Chattahoochee-Flint (ACF) River Basin.\n02: Accounting unit for smaller drainage areas within this river basin.\n04: Refers to a different sub-basin within the Apalachicola-Chattahoochee-Flint River Basin.",
    },
    "03070203": {
      description:
        "03: South Atlantic-Gulf Region (major river systems that drain into the Atlantic and Gulf of Mexico).\n07: Subregion within the South Atlantic-Gulf, specifically related to the Apalachicola-Chattahoochee-Flint (ACF) River Basin.\n02: Accounting unit for smaller drainage areas within this river basin.\n03: Represents another distinct sub-basin within the Apalachicola-Chattahoochee-Flint Basin.",
    },
    "03080201": {
      description:
        "03: South Atlantic-Gulf Region (major river systems that drain into the Atlantic and Gulf of Mexico).\n08: Subregion, corresponding to the Suwannee River Basin.\n02: Accounting unit for smaller drainage areas.\n01: Sub-basin or watershed within the Lower Suwannee River Basin.",
    },
    "03080103": {
      description:
        "03: South Atlantic-Gulf Region (major river systems that drain into the Atlantic and Gulf of Mexico).\n08: Suwannee River Basin.\n01: Upper Suwannee River Basin.\n03: Specific sub-basin within the Upper Suwannee River Basin.",
    },
  };
  const schoolLevelDesc: any = {
    e: {
      title: "e - Elementary",
    },
    m: {
      title: "m - Middle",
    },
    h: {
      title: "h - High",
    },
    p: {
      title: "p - Primary",
    },
  };

  const getSchoolContent = () => {
    if (schoolLevel?.length === 1) {
      return schoolLevelDesc[schoolLevel];
    } else {
      const arr = schoolLevel?.split(",").map((val: any) => {
        return schoolLevelDesc[val];
      });
      return arr;
    }
  };
  const content = riskType !== null ? riskContent[riskType] : null;
  const floodZoneContent = floodZone !== null ? floodContent[floodZone] : null;
  const floodZoneSubTypeContent =
    floodZoneSubType !== null ? floodSubtypeContent[floodZoneSubType] : null;
  const fireZoneContent = fireZone !== null ? fireContent[fireZone] : null;
  const schoolLevelContent = schoolLevel !== null ? getSchoolContent() : null;
  const floodZoneHUCCodeContent =
    floodZoneHUCCode !== null ? hucDescriptions[floodZoneHUCCode] : null;
  const getPopoverContent = () => {
    switch (popoverContent) {
      case "inundationRisk":
        return (
          <Typography sx={{ p: 2 }}>
            <IconButton
              onClick={handleClose}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
            <h4>{content.title || ""}</h4>
            <p>
              <strong>Description:</strong> {content.description || ""}
            </p>
            <p>
              <strong>Implications:</strong> {content.implications || ""}
            </p>
          </Typography>
        );
      case "floodIcon":
        return (
          <Typography sx={{ p: 2 }}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
            <h4>Flood Zone Details</h4>
            <p>{floodZoneContent.description}</p>
          </Typography>
        );
      case "schoolLevel":
        return (
          <Typography sx={{ p: 2 }}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
            <h4>School Level Details</h4>
            <p>
              {!isArray(schoolLevelContent)
                ? schoolLevelContent.title
                : schoolLevelContent.map((con) => {
                    return <p>{con.title}</p>;
                  })}
            </p>
          </Typography>
        );
      case "floodSubType":
        return (
          <Typography sx={{ p: 2 }}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
            <h4>Flood ZoneSubType Details</h4>
            <p>{floodZoneSubTypeContent.description}</p>
          </Typography>
        );
      case "floodHUCCode":
        return (
          <Typography sx={{ p: 2 }}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
            <h4>Flood Zone HUC Code Details: ({floodZoneHUCCode})</h4>
            <ul>
              {floodZoneHUCCodeContent.description
                .split("\n")
                .map((line: any, index: any) => (
                  <li key={index}>{line.trim()}</li>
                ))}
            </ul>
          </Typography>
        );
      case "fireIcon":
        return (
          <Typography sx={{ p: 2 }}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
            <h4>Responsibility Area Details</h4>
            <p>{fireZoneContent.description}</p>
          </Typography>
        );
      default:
        return null;
    }
  };

  const getMapChart = () => {
    return (
      <Typography sx={{ p: 2 }}>
        <IconButton
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "-4px",
            right: "6px",
            color: "white",
            cursor: "pointer",
            zIndex: 100,
          }}
        >
          <CloseIcon />
        </IconButton>
        <MonthlyPredictionChart data={mapChartData} />
      </Typography>
    );
  };
  return (
    <>
      <div id={layerLoading ? "loadingMapContainer" : "mapContainer"}>
        <>
          {showHeatMap && (
            <div id="floating-panel">
              <Button
                id="high_expected_returns"
                variant="contained"
                size="small"
                className="map-button selected"
              >
                Expected Returns
              </Button>
              <Button
                id="days_on_market_mean"
                variant="contained"
                size="small"
                className="margin-left map-button"
              >
                Days On Market
              </Button>
              <Button
                id="home_sales_cumulative_mean"
                variant="contained"
                size="small"
                className="margin-left map-button"
              >
                Home Sales
              </Button>
              <Button
                id="ppsf_Growth_mean"
                variant="contained"
                size="small"
                className="margin-left map-button"
              >
                PPSF Growth
              </Button>
              <Button
                id="dom_growth_months"
                variant="contained"
                size="small"
                className="margin-left map-button"
              >
                Days On Market Change
              </Button>
              <Button
                id="hs_growth_months"
                variant="contained"
                size="small"
                className="margin-left map-button"
              >
                Home Sales Growth
              </Button>
            </div>
          )}
        </>

        <div id="heatMap" />

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          sx={{
            mt: popoverContent === "fireIcon" ? 2 : 4, // Margin to adjust vertical position
            ml: mapChart
              ? 33
              : popoverContent === "floodIcon"
              ? 30
              : popoverContent === "fireIcon"
              ? 36.5
              : popoverContent === "inundationRisk"
              ? -18.5
              : 0,
            "& .MuiPopover-paper": {
              // Styles applied to the paper element of the Popover
              width: popoverContent === "schoolLevel" ? "350px" : "750px", // Fixed width
              maxWidth: "750px", // Max width to prevent overflow
              overflow: "hidden", // Prevent scrolling
              whiteSpace: "normal", // Ensures text wraps properly
              wordWrap: "break-word", // Forces long words to wrap within the container
            },
          }}
        >
          {mapChart ? getMapChart() : getPopoverContent()}
        </Popover>
        <div id={chartData.dialog ? "heatMapDialogToggle" : "heatMapToggle"}>
          {chartData.schoolData && chartData.schoolData.length != 0 && (
            <FormControlLabel
              control={
                <Checkbox
                  id="schoolCheckBox"
                  checked={showSchoolData}
                  onChange={handleSchoolToggle}
                  sx={{ color: "white" }}
                />
              }
              label="Show School Details"
              sx={{ color: "white" }}
            />
          )}
          <FormControlLabel
            control={
              <Checkbox
                id="checkBox"
                checked={showHeatMap}
                onChange={handleToggle}
                sx={{ color: "white" }}
              />
            }
            label="Show Heat Map"
            sx={{ color: "white" }}
          />
        </div>

        <ToggleButtonGroup
          value={mapType}
          id="mapType"
          exclusive
          onChange={handleChange}
          aria-label="map type"
          sx={{ mb: 2 }}
        >
          <ToggleButton
            value={google.maps.MapTypeId.TERRAIN}
            aria-label="terrain"
            className="mapToggleButton"
            sx={{
              border: mapType === "terrain" ? "2px solid #FFFFFF" : "none", // Add border when selected
              borderRadius: "5px", // Optional: Add rounded corners
            }}
          >
            <img src={terrain} width="28px" height="28px"></img>
          </ToggleButton>
          <ToggleButton
            value={google.maps.MapTypeId.HYBRID}
            aria-label="satellite"
            className="mapToggleButton"
            sx={{
              border: mapType === "hybrid" ? "2px solid #FFFFFF" : "none", // Add border when selected
              borderRadius: "5px", // Optional: Add rounded corners
            }}
          >
            <img src={satellite} width="28px" height="28px"></img>
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      {layerLoading && (
        <div id="heatMapLoader">
          <Bars
            height="1000"
            ariaLabel="bars-loading"
            wrapperClass="spinner-progress-bar"
            visible={true}
          />
        </div>
      )}
    </>
  );
};

export default Map;
